/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import ReactDOM from 'react-dom';
import throttle from 'lodash/throttle';
import isEqual from 'lodash/isEqual';
import {
  isAndroidWeb,
  removeRecFromStorage,
  setSessionStorage,
} from '@tcp/core/src/utils/utils.web';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore.js';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import SocialProofMessage from '@tcp/core/src/components/features/browse/ProductDetail/molecules/SocialProofMessage/container/SocialProofMessage.container';
import { fromJS } from 'immutable';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import SelectBox from '@tcp/core/src/components/common/atoms/Select';
import { PRODUCT_ADD_TO_BAG } from '@tcp/core/src/constants/reducer.constants';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import MiniBagSelect from '@tcp/web/src/components/features/CnC/MiniBag/molecules/MiniBagSelectBox/MiniBagSelectBox';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { markPriceIncluded } from '@tcp/core/src/components/common/molecules/Accessories/util/utility';
import productUtil from '@tcp/core/src/services/abstractors/productListing/ProductDetail.util';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getIsAllowOnlineProductPickupEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getViewportInfo,
  isClient,
  isSafariBrowser,
  addRecommendationsObj,
  onTabClickDetails,
  getSelectedMultipack,
  findMultipacks,
  getAPIConfig,
  getBrand,
  getSiteId,
  getLocator,
  isPJP,
  getBrandInCaps,
  isMobileWeb,
  scrollToBreadCrumb,
  getIconPath,
  getAssetHostURL,
} from '@tcp/core/src/utils';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import isEmpty from 'lodash/isEmpty';
import ReactTooltip from '@tcp/core/src/components/common/atoms/ReactToolTip';
import { CALL_TO_ACTION_VISIBLE, CONTROLS_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import { isTier3Device } from '@tcp/web/src/utils/device-tiering';
import {
  getMapSliceForColorProductId,
  getSkuId,
  getFeatures,
  setSelectedPack,
  filterCurrentSelectedProduct,
  getSoftClass,
  getFormValue,
  checkAvailablePill,
  getSoftDisableMutiPack,
  getPrimaryImages,
  getMapSliceForColor,
  getProductListToPath,
  getIsOnlineExclusive,
  getPrices,
  getSecondaryAccessoryList,
  getBrandName,
  getImagesToDisplay,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import Product from '@tcp/core/src/components/features/browse/ProductDetail/molecules/Product/views/Product.view';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels.js';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import ProductPickupContainer from '@tcp/core/src/components/common/organisms/ProductPickup';
import { getPlpLabelsCopy } from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors.js';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels.js';
import { getLabelsOutOfStockCopy } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors.js';
import { getQuickViewLabelsCopy } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { getQuickViewLabels } from '@tcp/core/src/components/common/organisms/PickupStoreModal/molecules/PickupStoreSelectionForm/views/PickupStoreSelectionForm.labels';
import { pdpLabels } from '@tcp/core/src/components/common/organisms/PickupStoreModal/views/PickupStoreModal.labels';
import {
  GlobalAddToBagLabels,
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
} from '../../../../../utils/labels/globalAddedToBag.labels';
import ProductColorChipsSelector from '../../ProductColorChipSelector';
import ProductPrice from '../../../../features/browse/ProductDetail/molecules/ProductPrice/ProductPrice';
import ProductSizeSelector from '../../ProductSizeSelector';
import AlternateSizes from '../molecules/AlternateSizes';
import ErrorComp from '../molecules/ErrorMessage/ErrorMessage';
import styles, {
  giftCardDesignStyle,
  StyledFulfillmentSectionContainer,
  EarlyAccessDate,
  TireDynamicButton,
} from '../styles/ProductAddToBag.style';
import SIZE_CHART_LINK_POSITIONS, { MULTI_PACK_TYPE } from '../container/ProductAddToBag.config';
import {
  getCategoryIdAndName,
  getGAPageName,
  getSessionStorage,
} from '../../../../../utils/utils.web';
import PreOrderDate from '../../../../features/CnC/common/molecules/PreOrderDate/container';
import { getCartItemInfo } from '../../../../features/CnC/AddedToBag/util/utility';
import {
  isGetSecondaryData,
  getPickupOptionOnInitialization,
  getDepartmentSwatches,
  fetchFilteredSwatch,
  getDepartmentsNew,
  getUpdatedDepts,
} from '../util/utility';
import { propTypesWeb, defaultPropsWeb } from './ProductAddToBagPropTypes';
import { SLASH_C_ROUTE } from '../../../../../constants/plp.constants';
import { setUserSelection } from '../../../../../utils/userPersonalization';
import BuyItAgainDynamicStore from '../../../../features/account/BuyItAgain/container/BuyItAgainDynamicStore';
import { PDP_SUB_LABELS, pdpSubLabels } from '../../../../../utils/labels/browse/PDP.labels';
import {
  CmnBrowse,
  PdpSub,
} from '../../../../features/browse/ProductDetail/views/ProductDetail.labels';
import Image from '../../../atoms/Image';
import { distancesMap } from '../../../organisms/PickupStoreModal/PickUpStoreModal.config';
import { getAddressLocationInfo } from '../../../../../utils/addressLocation';

const AccessoriesContainer = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "AccessoriesContainer" */ '../../Accessories/container/Accessories.container'
  )
);

const StickyAtbHeader = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "StickyAtbHeader" */ '../molecules/StickyAtbHeader/views/StickyAtbHeader.view'
  )
);

const SizeChart = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "SizeChart" */ '../molecules/SizeChart/container'
  )
);

const DELIVERY_METHODS = {
  HOME: 'home',
  BOPIS: 'bopis',
  BOSS: 'boss',
};
let buttonIndex = 0;
const DEFAULT_EVENTS = 'scAdd,scOpen,event85,event61';

const ProductDetailSectionSkeleton = () => {
  return (
    <div className="product-property-section">
      <LoaderSkelton height="40px" />
    </div>
  );
};

const ProductDetailMoreSizeSkeleton = () => {
  return (
    <div className="product-property-section">
      <LoaderSkelton height="40px" width="60%" />
    </div>
  );
};

class ProductAddToBag extends React.Component {
  constructor(props) {
    super(props);
    this.isMobile = isClient() ? getViewportInfo().isMobile : null;
    this.isTablet = isClient() ? getViewportInfo().isTablet : null;
    this.ATC_BUTTON = 'add-to-bag-button';
    this.quickViewDrawerClass = 'quick-view-drawer-redesign';
    this.disableClass = 'disable-add-to-bag';
    this.errorRef = React.createRef();

    const dpt = props.alternateStyles || {};
    const dptList = getDepartmentsNew(props.currentProduct.consolidatedDept);
    const { genderAgeGroup, seoToken } = props?.currentProduct || {};
    const updatedDpt = getUpdatedDepts(dpt, genderAgeGroup, props?.colorDisplayId, seoToken);
    const dptSwatchList = getDepartmentSwatches(updatedDpt);
    this.state = {
      showStickyATC: false,
      showStickyPickUp: false,
      IsCallToActionVisible: false,
      quantity: 1,
      isPickUpSelected: getPickupOptionOnInitialization(props),
      colorListWithSelectedItemFirst: {},
      hasMounted: false,
      departments: dptList,
      departmentSwatches: dptSwatchList,
      filteredSwatches: dptList.length
        ? fetchFilteredSwatch(dptSwatchList, props.initialValues.Department)
        : [],
    };
    this.pickupSelectionUpdate = this.pickupSelectionUpdate.bind(this);
    if (props.isPDP) {
      this.handleScrollThrottle = throttle(this.handleScroll, 100);
    }
    this.mTabRef = React.createRef();
    this.mlistRef = React.createRef();
    this.isSizeSelected = false;
    this.isSecondaryAccessories = null;
    this.prevProdId = '';
    this.nearBylabel = getLabelFromCopyOrFromTranslation(
      `${PDP_SUB_LABELS}.lbl_select_nearby_check`,
      pdpSubLabels
    );

    this.commmonBrowseLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_COMMON_BROWSE_LABELS,
      globalCommonBrowseLabels
    );

    const addedToBagLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_ADD_TO_BAG_MODAL_LABELS,
      GlobalAddToBagLabels
    );
    this.outOfStockLabels = getLabelsOutOfStockCopy(this.commmonBrowseLabels) || {};
    this.plpLabelsObj = getLabelFromCopyOrFromTranslation('PLP', PLPLabels);
    this.plpLabels = getPlpLabelsCopy(this.plpLabelsObj);
    this.addedToBagLabel = renderLabel(
      addedToBagLabels?.lbl_header_addedToBag,
      'lbl_header_addedToBag'
    );
    this.pdpLabels = this.getPdpLabels();
    this.qvLabelsObj = getQuickViewLabels();
    this.quickViewLabels = getQuickViewLabelsCopy(this.qvLabelsObj);
  }

  componentWillMount() {
    const {
      TCPMultipackProductMapping,
      selectedMultipack,
      TCPStyleQTY,
      setSelectedMultipack,
      isPDP,
      isModalOpen,
    } = this.props;
    this.makeSelectedColorAsFirst();
    /* eslint-disable no-extra-boolean-cast */
    const multipackToShow = !!selectedMultipack ? selectedMultipack : Number(TCPStyleQTY);

    if (isPDP && !isModalOpen) {
      setSelectedPack(setSelectedMultipack, multipackToShow, TCPMultipackProductMapping);
    }
  }

  setStickyCTA = () => {
    try {
      if (isClient() && window && document) {
        const atbContent = document.querySelector('.product-customize-form-container');
        const addtobagsectionwrapper = document.querySelector('.add-to-bag-section-wrapper');
        if (atbContent && addtobagsectionwrapper && addtobagsectionwrapper.classList) {
          const { offsetHeight } = atbContent;
          const { innerHeight } = window;
          if (
            offsetHeight &&
            innerHeight &&
            innerHeight > 700 &&
            innerHeight - offsetHeight > 100
          ) {
            addtobagsectionwrapper.classList.add('position-absolute');
          } else {
            addtobagsectionwrapper.classList.remove('position-absolute');
          }
        }
      }
    } catch (ex) {
      console.debug(ex);
    }
  };

  fetchStorePayload = () => {
    const { userDefaultStore, mapboxStoreSearchTypesParam, isBopisMultipleStoreEnabled } =
      this.props;

    const LATLONG_COOKIE = 'tcpGeoLoc';
    const distance = distancesMap[0]?.id;
    const country = getSiteId() && getSiteId().toUpperCase();
    const zipCode = userDefaultStore?.basicInfo?.address?.zipCode;
    const latLong = readCookie(LATLONG_COOKIE);
    let locationPromise = null;

    if (zipCode) {
      const addressFormData = {
        addressLocation: zipCode,
        distance: 25,
      };

      locationPromise =
        addressFormData &&
        getAddressLocationInfo(addressFormData?.addressLocation, mapboxStoreSearchTypesParam);
    } else if (latLong) {
      const [lat, long] = latLong.split('|');
      const geometry = {
        location: {
          lat,
          lng: long,
        },
      };
      locationPromise = Promise.resolve(geometry?.location);
    }

    return {
      distance,
      locationPromise,
      country,
      defaultStore: userDefaultStore,
      isBopisMultipleStoreEnabled,
    };
  };

  componentDidMount() {
    const {
      showAddToBagCTA,
      fromPage,
      updatePickupSelectedState,
      updatePickupSelectedAtProductDetail,
      isBopisMultipleStoreEnabled,
      storeIdList,
      currentProduct,
      getBopisStores,
      isStoreSpecialPriceEnabled,
      getTierBenefits,
      loyaltyTierBenefits,
    } = this.props;
    const { isPickUpSelected } = this.state;
    if (showAddToBagCTA) {
      this.setState({ IsCallToActionVisible: true });
    }
    updatePickupSelectedState(isPickUpSelected);
    this.setState({ hasMounted: true });
    this.updateMultipackPill();
    this.addStickyListeners();
    if (fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') {
      window.addEventListener('resize', this.setStickyCTA);
    }
    if (isPickUpSelected === 'bopis') {
      updatePickupSelectedAtProductDetail(true);
    } else {
      updatePickupSelectedAtProductDetail(false);
    }

    const { generalProductId, colorFitsSizesMap } = currentProduct;

    const currentColorEntry =
      getMapSliceForColorProductId(colorFitsSizesMap, generalProductId) || {};
    const variantId = currentColorEntry?.fits[0]?.sizes[0]?.variantId;
    const storeSpecials = isStoreSpecialPriceEnabled && currentColorEntry?.storeSpecials;

    if (storeSpecials && isBopisMultipleStoreEnabled && storeIdList?.length === 0) {
      const fetchPayload = this.fetchStorePayload();
      fetchPayload.variantId = variantId;
      fetchPayload.skuId = variantId;
      fetchPayload.quantity = 1;
      fetchPayload.nearestStoreUpdateFlag = true;
      fetchPayload.currentSelectedPickUpTypeOnPDP = 'bopis';
      getBopisStores(fetchPayload);
    }

    if (!loyaltyTierBenefits) {
      getTierBenefits({});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(nextProps, this.props) && isEqual(nextState, this.state));
  }

  componentWillUpdate(nextProps) {
    const {
      TCPStyleType,
      TCPMultipackProductMapping: prevMultiPackMappings,
      setAddToPickupError,
      addToPickupError,
      isOpenAddedToBag,
      isSingleOptionEnabled,
      setInitialTCPStyleQty,
      fromPage,
      isSupressAtbModalOnBag,
    } = this.props;
    if ((!isSupressAtbModalOnBag || fromPage !== 'cart') && addToPickupError && !isOpenAddedToBag) {
      setAddToPickupError('');
    }
    if (
      (!isSingleOptionEnabled || (isSingleOptionEnabled && setInitialTCPStyleQty === '1')) &&
      (TCPStyleType === MULTI_PACK_TYPE.SINGLE ||
        (prevMultiPackMappings && prevMultiPackMappings.indexOf('1') > -1)) &&
      nextProps.TCPMultipackProductMapping?.indexOf('1') < 0
    ) {
      nextProps.TCPMultipackProductMapping.unshift('1');
    }
    this.addStickyListeners();
  }

  setShowAddedText = (value) => {
    this.setState({ showAddedText: value });
  };

  getSocialProofMsg = () => {
    const {
      socialProofMessage,
      selectedSize,
      sfccSocialProofingOn,
      sfccSocialProofingThreshold,
      sizeList,
    } = this.props;
    const { isPickUpSelected } = this.state;

    let sfccSocialProofMsg = '';
    if (sfccSocialProofingOn && selectedSize?.name && isPickUpSelected === DELIVERY_METHODS.HOME) {
      // set social proof msg
      const selectedSizeOption = sizeList?.find((sizeItem) => {
        return (sizeItem && sizeItem.displayName) === (selectedSize && selectedSize.name);
      });
      const { socialProofingQty = 0, disabled } = selectedSizeOption || {};

      if (socialProofingQty > 0 && socialProofingQty < sfccSocialProofingThreshold && !disabled) {
        let spm = getDynamicLabelValues('dynamic.browse_d.lbl_social_proofing_msg5');
        spm = spm?.replace('$XX', socialProofingQty?.toString());
        sfccSocialProofMsg = {
          priorityMsg: spm,
          variation: 'bottom',
        };
      }
    }
    return sfccSocialProofMsg || socialProofMessage;
  };

  componentDidUpdate(prevProps) {
    const {
      selectedQuantity,
      selectedAccessories,
      accessoriesData,
      accessoriesDataQV,
      autoIncrementAccessaryOnQuantityChange,
      parentProductQtyChange,
      secondarySelectedAccessoryList,
      fromPage,
      selectedSize,
      currentProduct,
      handleFormSubmit,
      isPDP,
      isAccessoriesEnabled,
      colorList,
      clearSelectedAccessories,
      selectedColor,
      isBopisSelected,
      alternateStyles,
      colorDisplayId,
      updatePickupSelectedState,
      isBopisFilterOn,
      addedToBagBtnLoader,
      addToPickupError,
      errorOnHandleSubmit,
      updatePickupSelectedAtProductDetail,
      isBopisMultipleStoreEnabled,
      storeIdList,
      getBopisStores,
      selectedColorProductId,
      isStoreSpecialPriceEnabled,
      selectedFit,
      updateSimilarProducts,
    } = this.props;
    if (prevProps.addedToBagBtnLoader !== addedToBagBtnLoader) {
      if (addedToBagBtnLoader) {
        const timer = setTimeout(() => {
          this.setShowAddedText(true);
          clearTimeout(timer);
        }, 400);
      } else this.setShowAddedText(false);
    }

    if (
      prevProps.selectedQuantity !== selectedQuantity ||
      prevProps.selectedAccessories !== selectedAccessories
    ) {
      const { accessoriesProductID } = accessoriesData || {};
      const { product } = (accessoriesDataQV && accessoriesDataQV[0]) || {};
      const QVAccessoriesData = product && product.accessoriesData;
      const QVAccessoriesProductID = QVAccessoriesData?.accessoriesProductID || undefined;

      if (
        ((accessoriesProductID && accessoriesProductID?.length > 0) ||
          (QVAccessoriesProductID && QVAccessoriesProductID?.length > 0)) &&
        selectedAccessories &&
        selectedAccessories?.length > 0
      ) {
        autoIncrementAccessaryOnQuantityChange({
          selectedQuantity,
          selectedAccessories,
          secondarySelectedAccessoryList,
        });
      }
      parentProductQtyChange(selectedQuantity);
    }
    if (!isEqual(prevProps.colorList, colorList)) {
      this.makeSelectedColorAsFirst();
    }
    if (fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') {
      this.setStickyCTA();
    }
    if (
      isAccessoriesEnabled &&
      prevProps.selectedSize !== selectedSize &&
      accessoriesDataQV &&
      accessoriesDataQV[0] &&
      this.isSizeSelected
    ) {
      const { product } = accessoriesDataQV[0] || {};
      const QVAccessoriesData = product?.accessoriesData;
      const QVAccessoriesProductID = QVAccessoriesData?.accessoriesProductID || undefined;
      const isSecondaryAccessoriesData = isGetSecondaryData(
        fromPage,
        QVAccessoriesProductID,
        isPDP
      );
      if (isSecondaryAccessoriesData) {
        const { generalProductId } = currentProduct;
        if (
          QVAccessoriesProductID &&
          QVAccessoriesProductID.filter((item) => item === generalProductId)?.length
        ) {
          handleFormSubmit();
        }
      }
      this.isSizeSelected = false;
    }
    if (isAccessoriesEnabled && prevProps?.selectedColor?.name !== selectedColor?.name) {
      clearSelectedAccessories();
    }
    if (
      isAccessoriesEnabled &&
      selectedAccessories?.length > 0 &&
      prevProps.selectedAccessories !== selectedAccessories
    ) {
      const { customizationType } = accessoriesData || {};
      if (customizationType === 'optional' && isBopisSelected) {
        this.pickupSelectionUpdate('home');
      }
    }
    if (!isEqual(prevProps.alternateStyles, alternateStyles)) {
      const dpt = alternateStyles || {};
      const dptList = getDepartmentsNew(currentProduct.consolidatedDept);
      const { genderAgeGroup, seoToken } = currentProduct || {};
      const updatedDpt = getUpdatedDepts(dpt, genderAgeGroup, colorDisplayId, seoToken);
      const dptSwatchList = getDepartmentSwatches(updatedDpt);
      const dptFilteredList = dptList.length
        ? fetchFilteredSwatch(dptSwatchList, this.props.initialValues.Department)
        : [];
      this.setState({
        departments: dptList,
        departmentSwatches: dptSwatchList,
        filteredSwatches: dptFilteredList,
      });
    }
    if (prevProps.selectedColor !== selectedColor) {
      const { isPickUpSelected } = this.state;
      const newPickupOption = getPickupOptionOnInitialization(this.props);
      if (isPickUpSelected !== newPickupOption && isBopisFilterOn && isPickUpSelected === 'bopis') {
        this.setState({ isPickUpSelected: newPickupOption }, () => {
          updatePickupSelectedState(newPickupOption);
          updatePickupSelectedAtProductDetail(false);
        });
      }
    }

    if (this.prevProdId !== colorDisplayId && typeof updateSimilarProducts === 'function') {
      updateSimilarProducts(colorDisplayId || currentProduct.productId);
      this.prevProdId = colorDisplayId;
    }

    const productChanged =
      prevProps.selectedColorProductId !== selectedColorProductId ||
      prevProps.selectedFit?.name !== selectedFit?.name;
    if (productChanged) {
      const { colorFitsSizesMap } = currentProduct;
      const currentColorEntry =
        getMapSliceForColorProductId(colorFitsSizesMap, selectedColorProductId) || {};
      const variantId = currentColorEntry?.fits[0]?.sizes[0]?.variantId;
      const storeSpecials = isStoreSpecialPriceEnabled && currentColorEntry?.storeSpecials;
      if (
        storeSpecials &&
        isBopisMultipleStoreEnabled &&
        (storeIdList?.length === 0 || productChanged)
      ) {
        const fetchPayload = this.fetchStorePayload();
        fetchPayload.variantId = variantId;
        fetchPayload.skuId = variantId;
        fetchPayload.quantity = 1;
        fetchPayload.nearestStoreUpdateFlag = true;
        fetchPayload.currentSelectedPickUpTypeOnPDP = 'bopis';
        getBopisStores(fetchPayload);
      }
    }
    if (
      (!prevProps.errorOnHandleSubmit && errorOnHandleSubmit) ||
      (!prevProps.addToPickupError && addToPickupError)
    ) {
      this.errorRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  componentWillUnmount() {
    const { setStickyFooterState, isPDP, isStickyAtbHeader, fromPage, resetSimilarProductsActn } =
      this.props;
    if (isPDP && typeof resetSimilarProductsActn === 'function') {
      resetSimilarProductsActn();
    }
    if (isPDP && (this.isMobile || isStickyAtbHeader)) {
      window.removeEventListener('scroll', this.handleScrollThrottle);
      setStickyFooterState(false);
    }
    if (fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') {
      window.removeEventListener('resize', this.setStickyCTA);
    }
  }

  getPdpLabels = () => {
    const labelsObj1 = getLabelFromCopyOrFromTranslation(PdpSub, pdpLabels);
    const labelsObj2 = getLabelFromCopyOrFromTranslation('PLP.plpTiles', pdpLabels);
    const dynValue = getDynamicLabelValues('dynamic.browse_d.lbl_you_recently_viewed');
    const labelsObj3 = { lbl_you_recently_viewed: dynValue };
    const labelsObj4 = getLabelFromCopyOrFromTranslation('global.Sorting', pdpLabels);
    const labelsObj5 = getLabelFromCopyOrFromTranslation(CmnBrowse, pdpLabels);
    return { ...labelsObj1, ...labelsObj2, ...labelsObj3, ...labelsObj4, ...labelsObj5 };
  };

  makeSelectedColorAsFirst = () => {
    const {
      colorList,
      colorDisplayId,
      setAlternateStylesAct,
      currentProduct,
      isPDP,
      selectedColorProductId,
    } = this.props;
    const colorListSelectedValue = colorDisplayId
      ? colorList?.filter((item) => item?.colorDisplayId === colorDisplayId)
      : colorList;
    const colorListRestValues = colorList?.filter(
      (item) => item?.colorDisplayId !== colorDisplayId
    );
    const newColorListWithSelectedItemFirst =
      colorDisplayId && colorListSelectedValue?.length === 1
        ? [...colorListSelectedValue, ...colorListRestValues]
        : colorList;
    const newColorListMap = fromJS(newColorListWithSelectedItemFirst);
    this.setState({ colorListWithSelectedItemFirst: newColorListMap });
    if (isPDP) {
      const { allProductId } = currentProduct || {};
      const colorBasedAlternateStyle = productUtil.getAlternateStyleBasedOnSelectedColor(
        allProductId,
        selectedColorProductId
      );
      setAlternateStylesAct({ ...colorBasedAlternateStyle });
    }
  };

  addStickyListeners = () => {
    const { setStickyFooterState, isPDP, isStickyAtbHeader } = this.props;
    if (isPDP && (this.isMobile || isStickyAtbHeader)) {
      const { showStickyATC, showStickyPickUp } = this.state;
      if (!isStickyAtbHeader) setStickyFooterState(showStickyATC || showStickyPickUp);
      window.addEventListener('scroll', this.handleScrollThrottle);
    }
  };

  setStickyHeader = (isStickyATC) => {
    const { setStickyFooterState, isStickyAtbHeader } = this.props;

    if (!isStickyAtbHeader) {
      setStickyFooterState(isStickyATC);
    }
  };

  handleScroll = () => {
    const { isStickyAtbHeader } = this.props;
    const { isPickUpSelected, showStickyATC, showStickyPickUp } = this.state;
    const isPickupActive = isPickUpSelected !== DELIVERY_METHODS.HOME;

    const atcButtonWrapper = document.getElementsByClassName('outfit-button-wrapper')[0];
    const bossButtonWrapper = document.getElementsByClassName(
      'btn-find-in-store-wrapper-quick-view-drawer-redesign'
    )[0];
    const anchoringButton = isPickupActive ? bossButtonWrapper : atcButtonWrapper;
    const atcButton =
      anchoringButton &&
      anchoringButton.getElementsByClassName(
        isPickupActive ? 'button-find-in-store-quick-view-drawer-redesign' : this.ATC_BUTTON
      )[0];
    const footer = document.getElementsByClassName('footer-bottom')[0];
    const isScrolledPassATB = atcButton?.getBoundingClientRect()?.top < 0;
    const { isMobile } = getViewportInfo() || {};

    let stickyBtn = false;
    if (isStickyAtbHeader) {
      stickyBtn = this.shouldRenderStickyHeader(isPickupActive, true);
    } else {
      stickyBtn = isPickupActive ? this.renderStickyPickUp(true) : this.renderStickyATCButton(true);
    }

    const marginBottomClass =
      stickyBtn && isStickyAtbHeader ? 'marginBottomStickyHeader' : 'marginBottom';

    if (footer && isMobile && stickyBtn) {
      footer.classList.add(marginBottomClass);
    } else if (footer && isMobile && footer.classList.contains(marginBottomClass)) {
      footer.classList.remove(marginBottomClass);
    }
    const isStickyATC = isScrolledPassATB && stickyBtn;
    if (isPickupActive) {
      if (showStickyPickUp !== isScrolledPassATB) {
        this.setState({ showStickyPickUp: isScrolledPassATB });
        this.setStickyHeader(isStickyATC);
      }
    } else if (showStickyATC !== isScrolledPassATB) {
      this.setState({ showStickyATC: isScrolledPassATB });
      this.setStickyHeader(isStickyATC);
    }
  };

  checkIfThisIsSelectedAccessory = () => {
    const { selectedAccessories, generalProductId } = this.props;
    let flag = false;

    selectedAccessories?.forEach((item) => {
      if ((item?.skuInfo?.productId || item?.uniqueId) === generalProductId) {
        flag = true;
      }
    });
    return flag;
  };

  renderButtonOrAccessorySelected = () => {
    const { selectedAccessories, generalProductId, fromPage } = this.props;
    let accessoryItem = {};
    selectedAccessories?.forEach((item) => {
      if (item?.skuInfo?.productId === generalProductId) {
        accessoryItem = item;
      }
    });
    if (fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') {
      return accessoryItem?.varientCount <= 1;
    }
    return false;
  };

  getEarlyAccessAvailability = () => {
    const { initialFormValues, initialValues, currentProduct } = this.props;

    const getInitialFormVal = getFormValue(initialFormValues, initialValues);
    const getSelectedProductInformation = filterCurrentSelectedProduct(
      currentProduct.allProductId,
      getInitialFormVal
    );

    return getSelectedProductInformation?.early_access_availability;
  };

  getEarlyAccessHours = (loyaltyBenefits) => {
    if (!Array.isArray(loyaltyBenefits)) return null;

    const earlyAccessBenefit = loyaltyBenefits.find((benefit) => benefit.type === 'EarlyAccess');

    const hours = earlyAccessBenefit?.earlyAccessHours;
    return hours != null ? Number(hours) : null;
  };

  isProductAvailableForAccessHours = (earlyAccessAvailability, loyaltyTierBenefits) => {
    const accessHours = this.getEarlyAccessHours(loyaltyTierBenefits);

    if (!earlyAccessAvailability || accessHours === null || accessHours === undefined) {
      return false;
    }

    const now = new Date();
    const availabilityDate = new Date(earlyAccessAvailability);
    const accessStartTime = new Date(availabilityDate.getTime() - accessHours * 60 * 60 * 1000);

    return now >= accessStartTime && now < availabilityDate;
  };

  getAddToBagLabel = (addToBagLabel) => {
    const { selectedAccessories, secondarySelectedAccessoryList, selectedQuantity } = this.props;
    return selectedAccessories?.length > 0
      ? `${addToBagLabel} (${
          (selectedAccessories?.length + secondarySelectedAccessoryList?.length) *
            selectedQuantity +
          selectedQuantity
        })`
      : addToBagLabel;
  };

  getButtonLabel = () => {
    const {
      fromBagPage,
      keepAlive,
      isFavoriteEdit,
      checkForOOSForVariant,
      isNewPDPEnabled,
      fromPage,
      tempSecondarySelectedAccessoryList,
      currentProduct,
      selectedAccessories,
      isLoyaltyTierEnabled,
      loyaltyTierBenefits,
    } = this.props;
    const { addToBag, update, saveProduct, selectAddOn, updateAddOn, addToBagTierBased } =
      this.plpLabels;
    const { productId } = currentProduct;
    let addToBagLabel = addToBag;
    const earlyAccessAvailability = this.getEarlyAccessAvailability();
    const isFutureDate = new Date(earlyAccessAvailability) > new Date();
    const isAvailable = this.isProductAvailableForAccessHours(
      earlyAccessAvailability,
      loyaltyTierBenefits
    );

    if (isLoyaltyTierEnabled && isFutureDate && !isAvailable) {
      addToBagLabel = addToBagTierBased;
      return addToBagLabel;
    }
    if (fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') {
      if (selectedAccessories?.length || tempSecondarySelectedAccessoryList?.length) {
        const filterSecondarySelectedAccessory = getSecondaryAccessoryList(
          tempSecondarySelectedAccessoryList,
          productId
        );
        const qty = filterSecondarySelectedAccessory?.length
          ? `(${filterSecondarySelectedAccessory?.length + 1})`
          : '';
        return `${this.checkIfThisIsSelectedAccessory() ? updateAddOn : selectAddOn} ${qty}`;
      }
      return selectAddOn;
    }
    if (fromBagPage) {
      addToBagLabel = update;
    } else if (isFavoriteEdit) {
      addToBagLabel = saveProduct;
    }
    if (isNewPDPEnabled) {
      addToBagLabel = this.getAddToBagLabel(addToBagLabel);
      return keepAlive || checkForOOSForVariant
        ? this.outOfStockLabels?.outOfStockCaps
        : addToBagLabel;
    }
    addToBagLabel = this.getAddToBagLabel(addToBagLabel);
    return keepAlive || checkForOOSForVariant
      ? this.outOfStockLabels?.outOfStockCaps
      : addToBagLabel || this.addedToBagLabel;
  };

  renderOutfitButton = () => {
    const {
      currentProduct,
      currentProduct: { colorFitsSizesMap },
      selectedColorProductId,
      isOutfitPage,
      keepAlive,
      isOutfitCarousel,
      isNewPDPEnabled,
      checkForOOSForVariant,
      accessoriesData,
      selectedSize,
      displayErrorMessage,
      formValues,
      isVMPBossEligible,
    } = this.props;
    let isBopisEligibleFlag;
    const currentColorEntry =
      getMapSliceForColorProductId(colorFitsSizesMap, selectedColorProductId) || {};
    const isAllSizeDisabled = this.checkIfAllSizeIsDisabled();
    let selectedSizeValue = selectedSize?.name;
    if (!selectedSizeValue && typeof formValues?.[0]?.size === 'string') {
      selectedSizeValue = formValues?.[0]?.size;
    }
    if (currentColorEntry) {
      isBopisEligibleFlag =
        currentColorEntry.miscInfo && currentColorEntry.miscInfo.isBopisEligible;
    }
    return isOutfitPage && !isOutfitCarousel && isBopisEligibleFlag ? (
      <div className="outfit-pickup">
        <ProductPickupContainer
          productInfo={currentProduct}
          formName={`ProductAddToBag-${currentProduct.generalProductId}`}
          miscInfo={currentColorEntry && currentColorEntry.miscInfo}
          isOutfitVariant
          keepAlive={keepAlive}
          quickViewLabels={this.quickViewLabels}
          isNewPDPEnabled={isNewPDPEnabled}
          checkForOOSForVariant={checkForOOSForVariant}
          isAllSizeDisabled={isAllSizeDisabled}
          accessoriesData={accessoriesData}
          selectedSizeValue={selectedSizeValue}
          displayErrorMessage={displayErrorMessage}
          isVMPBossEligible={isVMPBossEligible}
        />
      </div>
    ) : (
      <div className="outfit-pickup" />
    );
  };

  skeletonCheck = (isLoading, isPDP, setInitialQuickViewLoad) => {
    return isLoading && !isPDP && setInitialQuickViewLoad;
  };

  colorListNullCheck = (showColorChips, colorList) => {
    const { isNewPDPEnabled } = this.props;
    return isNewPDPEnabled
      ? showColorChips && colorList && colorList.size > 1
      : showColorChips && colorList && colorList.size > 0;
  };

  getPageName = (productInfo) => {
    let pageName = '';
    const productId = productInfo && productInfo?.generalProductId?.split('_')[0];
    const productName = productInfo && productInfo?.name?.toLowerCase();
    if (productId) {
      pageName = `product:${productId}:${productName}`;
    }
    return {
      pageName,
    };
  };

  getIsStoreBopisEligible = (bopisItemInventory, defaultSuggestStore, isBopisMultiStoreEnabled) => {
    if (isBopisMultiStoreEnabled) {
      const defaultStoreId = defaultSuggestStore && defaultSuggestStore[0]?.basicInfo?.id;
      const filterInventoryResponse = bopisItemInventory?.inventoryResponse?.filter(
        (store) => store?.storeId === defaultStoreId
      );
      return (
        filterInventoryResponse &&
        filterInventoryResponse?.length > 0 &&
        filterInventoryResponse[0].quantity > 0
      );
    }
    return (
      bopisItemInventory &&
      bopisItemInventory?.inventoryResponse &&
      bopisItemInventory?.inventoryResponse?.length > 0 &&
      bopisItemInventory?.inventoryResponse[0].quantity > 0
    );
  };

  checkForSizeMismatchBetweenFits = (colorFitsSizesMap, formValues) => {
    const filteredColorElement =
      colorFitsSizesMap &&
      colorFitsSizesMap.find((colorElement) => {
        return (
          (colorElement && colorElement.color && colorElement.color.name) ===
          (formValues && formValues.color)
        );
      });
    const filteredSizeArray =
      filteredColorElement &&
      filteredColorElement.fits &&
      filteredColorElement.fits.find((fitsItem) => {
        return (fitsItem && fitsItem.fitName) === (formValues && formValues.fit);
      });
    const selectedSizeAvail =
      filteredSizeArray &&
      filteredSizeArray.sizes &&
      filteredSizeArray.sizes.some((sizeDetails) => {
        return (sizeDetails && sizeDetails.sizeName) === (formValues && formValues.size);
      });
    return !selectedSizeAvail;
  };

  handlePickupFormSubmit = (e) => {
    const {
      formValues,
      displayErrorMessage,
      currentProduct,
      isStickyAtbHeader,
      accessoriesDataQV,
      tempSecondarySelectedAccessoryList,
      displayAccessoriesErrorMessage,
      selectedAccessories = [],
      isAccessoriesEnabled,
      fromBagPage,
      fromPage,
      accessoriesData,
    } = this.props;
    let isFromPickupButton = false;
    if (e && e.target && e.target.name && e.target.name === 'pickupStoreButton')
      isFromPickupButton = true;
    const { product } = (accessoriesDataQV && accessoriesDataQV[0]) || {};
    const QVAccessoriesData = product && product.accessoriesData;
    const { customizationType } = accessoriesData || {};
    const secondaryAccessorySelected =
      product &&
      tempSecondarySelectedAccessoryList &&
      tempSecondarySelectedAccessoryList?.filter(
        (accessory) => accessory.parentProductId === product.generalProductId
      );
    const QVAccessoriesCustomizationType = QVAccessoriesData?.customizationType || '';
    const updatedForm = Array.isArray(formValues) ? formValues[0] : formValues;
    const { isPickUpSelected } = this.state;
    const { colorFitsSizesMap } = currentProduct;
    const selectedSizeValue = this.getSelecterSizeValue();
    const stickyBtn = isStickyAtbHeader
      ? this.shouldRenderStickyHeader(true)
      : this.renderStickyPickUp();
    const isSizeDisabled = this.checkIfSizeIsDisabled();
    const isBoss = isPickUpSelected === DELIVERY_METHODS.BOSS;
    let isSizeMisMatchBetweenFits = false;
    if (
      colorFitsSizesMap &&
      updatedForm &&
      updatedForm.color &&
      selectedSizeValue &&
      updatedForm.fit !== null
    ) {
      isSizeMisMatchBetweenFits = this.checkForSizeMismatchBetweenFits(
        colorFitsSizesMap,
        updatedForm
      );
    }
    e.preventDefault();

    if (
      !selectedSizeValue ||
      (isBoss && isSizeDisabled) ||
      isSizeMisMatchBetweenFits ||
      (isAccessoriesEnabled &&
        !fromBagPage &&
        ((customizationType === 'mandatory' &&
          fromPage !== 'fromPDPAccessories' &&
          fromPage !== 'fromQVAccessories') ||
          QVAccessoriesCustomizationType === 'mandatory') &&
        (selectedAccessories?.length < 1 ||
          (this.isSecondaryAccessories && secondaryAccessorySelected?.length < 1)) &&
        !(
          QVAccessoriesCustomizationType === 'mandatory' &&
          secondaryAccessorySelected &&
          secondaryAccessorySelected?.length
        ))
    ) {
      displayErrorMessage(true);
      displayAccessoriesErrorMessage(
        this.isSecondaryAccessories ? secondaryAccessorySelected : selectedAccessories
      );

      const form = e?.target?.form;
      if (form) {
        const headingElem = form.querySelector('.select-value-wrapper');
        if (headingElem) {
          const timer = setTimeout(() => {
            headingElem.scrollIntoView({ behavior: 'smooth', block: 'center' });
            clearTimeout(timer);
          }, 250);
        }
      }
      if (stickyBtn) this.scrollIntoView();
    } else {
      displayErrorMessage(false);
      this.handlePickupModalClick(selectedSizeValue, isBoss, isFromPickupButton);
    }
  };

  checkNearestStoresHaveDefaultStore = (userDefaultFavStore) => {
    const { nearestAvailableStore } = this.props;

    const arr = nearestAvailableStore?.filter(
      (store) => userDefaultFavStore?.basicInfo?.storeName === store?.basicInfo?.storeName
    );
    return arr?.length;
  };

  setStorePickupJourney = (payload, productInfo) => {
    const { nearestAvailableStore } = this.props;
    const { isPickUpSelected } = this.state;
    const newPayload = payload;
    const userDefaultFavStore = JSON.parse(getLocalStorage('defaultStore')) || {};
    const checkNearestStoresHaveDefaultStore = this.checkNearestStoresHaveDefaultStore();
    const noOfStores = nearestAvailableStore?.length - checkNearestStoresHaveDefaultStore;
    const storeName = userDefaultFavStore?.basicInfo?.storeName;
    const key = 'bopisFavorNonFavStore';
    let analyticValue;
    if (isPickUpSelected === 'boss') {
      analyticValue = `pdp_boss_fav_main-pickup-${storeName}`;

      if (userDefaultFavStore?.akamaiStoreFlag) {
        analyticValue = `pdp_boss_non-fav_main-pickup-${storeName}`;
      }
    }
    if (isPickUpSelected === 'bopis') {
      analyticValue = `pdp_fav_${noOfStores}_main-pickup-${storeName}`;
      if (userDefaultFavStore?.akamaiStoreFlag) {
        analyticValue = `pdp_non-fav_${noOfStores}_main-pickup-${storeName}`;
      }
    }
    newPayload.cd130 = analyticValue;
    const prodPartNo = productInfo?.skuInfo?.prodPartNo;
    const sessionValue = JSON.parse(getSessionStorage(key));
    const stringifiedSV = JSON.stringify({
      ...sessionValue,
      [prodPartNo]: analyticValue,
    });
    setSessionStorage({ key, value: stringifiedSV });
    return newPayload;
  };

  callFromAvailableStoreAction = (
    isBossMultiStoreEnabled,
    isBopisMultiStoreEnabled,
    fromBagPage,
    fromAvailableStoresClick,
    userDefaultFavStore
  ) => {
    if (
      (isBossMultiStoreEnabled || isBopisMultiStoreEnabled) &&
      !fromBagPage &&
      !userDefaultFavStore
    ) {
      fromAvailableStoresClick(true);
    }
  };

  /**
   * @method handlePickupModalClick -
   * method is responsible for invoking the method for open pickup modal
   */

  handlePickupModalClick = (selectedSizeValue, isBoss, isFromPickupButton = false) => {
    const {
      onPickUpOpenClick,
      currentProduct,
      onPickupClickAddon,
      itemBrand,
      availableTCPmapNewStyleId,
      initialMultipackMapping,
      setInitialTCPStyleQty,
      selectedColorProductId,
      alternateBrandFromUrl,
      alternateBrand,
      userDefaultStore,
      bopisItemInventory,
      fromAvailableStoresClick,
      isBossMultiStoreEnabled,
      isBopisMultiStoreEnabled,
      fromBagPage,
      userDefaultFavStore,
      defaultSuggestStore,
    } = this.props;
    const { isPickUpSelected } = this.state;
    const isStoreBopisEligible = this.getIsStoreBopisEligible(
      bopisItemInventory,
      defaultSuggestStore,
      isBopisMultiStoreEnabled
    );
    const isBopis = isPickUpSelected === DELIVERY_METHODS.BOPIS;
    const isBossEligible = userDefaultStore?.storeBossInfo?.isBossEligible;
    const isPickUpEligible =
      (isBoss && isBossEligible && !this.checkIfAllSizeIsDisabled()) ||
      (isBopis && isStoreBopisEligible);

    if (
      userDefaultStore &&
      userDefaultStore?.basicInfo?.id &&
      selectedSizeValue &&
      isPickUpEligible
    ) {
      this.handleAddItemToCartInPickup(isBopis, isBoss);
    } else {
      let isBopisEligibleFlag;
      let isBossEligibleFlag;

      const { colorFitsSizesMap } = currentProduct;
      const currentColorEntry =
        getMapSliceForColorProductId(colorFitsSizesMap, selectedColorProductId) || {};
      if (currentColorEntry) {
        isBopisEligibleFlag =
          currentColorEntry.miscInfo && currentColorEntry.miscInfo.isBopisEligible;
        isBossEligibleFlag =
          currentColorEntry.miscInfo && currentColorEntry.miscInfo.isBossEligible;
      }
      this.callFromAvailableStoreAction(
        isBossMultiStoreEnabled,
        isBopisMultiStoreEnabled,
        fromBagPage,
        fromAvailableStoresClick,
        userDefaultFavStore
      );
      onPickUpOpenClick({
        generalProductId: currentProduct.generalProductId,
        isBopisCtaEnabled: isBopisEligibleFlag,
        isBossCtaEnabled: isBossEligibleFlag,
        currentProduct: { ...currentProduct, itemBrand },
        colorProductId: currentProduct.generalProductId,
        isProductPickup: true,
        availableTCPmapNewStyleId,
        availableTCPMultipackProductMapping: initialMultipackMapping,
        initialSelectedQty: setInitialTCPStyleQty,
        setInitialTCPStyleQty,
        alternateBrand: alternateBrandFromUrl || alternateBrand,
        isBopisPickup: isBopis,
        isFromPickupButton,
        isPickUpSelected,
      });
      if (onPickupClickAddon) {
        onPickupClickAddon();
      }
    }
  };

  showFindInStore = () => {
    const { userDefaultStore, showPickupInfo } = this.props;
    return showPickupInfo && userDefaultStore;
  };

  getImageSwatches = (imagesByColor, updatedColorEntry, currentColorEntry) => {
    return imagesByColor
      ? getPrimaryImages({
          imagesByColor,
          curentColorEntry: !updatedColorEntry ? currentColorEntry : updatedColorEntry,
          isAbTestActive: false,
          isFullSet: true,
        })
      : null;
  };

  selectColourOnHover = (e, isNewQVEnabled) => {
    const { selectColorToHover, isPDP } = this.props;
    const notMobileTablet = !this.isMobile && !this.isTablet;
    return notMobileTablet && (!isNewQVEnabled || isPDP) ? selectColorToHover(e) : undefined;
  };

  renderColorList = (
    colorList,
    colorTitle,
    imageSwatchesToDisplay,
    newColorList,
    departmentPillsEnabled
  ) => {
    const {
      selectColor,
      isGiftCard,
      showColorChips,
      quickViewColorSwatchesCss,
      isPDP,
      isLoading,
      imagesByColor,
      relatedSwatchImages,
      itemBrand,
      isStyleWith,
      isImageSwatchDisabled,
      isBundleProduct,
      selectColorToHoverOut,
      setInitialQuickViewLoad,
      isABTestLoaded,
      currentProduct,
      formValues,
      isNewQVEnabled,
      isPickup,
      isNewPDPEnabled,
      primaryBrand,
      alternateBrand,
      fromBagPage,
      isNewPJPPDPRedesignEnabled,
      isPDPRedesignEnabled,
    } = this.props;
    const { generalProductId, colorFitsSizesMap } = currentProduct;

    const getFormName = Array.isArray(formValues) ? formValues[0]?.color : formValues?.color;
    let imageSwatchesToDisplayOnQV = [];
    const currentColorEntry =
      getMapSliceForColorProductId(colorFitsSizesMap, generalProductId) || {};
    const updatedColorEntry = getMapSliceForColor(colorFitsSizesMap, getFormName);
    imageSwatchesToDisplayOnQV = this.getImageSwatches(
      imagesByColor,
      updatedColorEntry,
      currentColorEntry
    );
    return this.skeletonCheck(isLoading, isPDP, setInitialQuickViewLoad) ? (
      <ProductDetailSectionSkeleton primaryBrand={primaryBrand} />
    ) : (
      showColorChips && this.colorListNullCheck(showColorChips, colorList) && (
        <div className="color-selector">
          <Field
            width={87}
            name="color"
            component={ProductColorChipsSelector}
            isGiftCard={isGiftCard}
            colorFitsSizesMap={colorList}
            onChange={selectColor}
            dataLocator="addnewaddress-state"
            title={!isStyleWith ? `${colorTitle}:` : ''}
            inheritedStyles={isGiftCard && isPDP ? giftCardDesignStyle : quickViewColorSwatchesCss}
            imagesByColor={imagesByColor}
            itemBrand={itemBrand}
            relatedSwatchImages={relatedSwatchImages}
            isStyleWith={isStyleWith}
            imageSwatchesToDisplay={
              isNewQVEnabled ? imageSwatchesToDisplayOnQV : imageSwatchesToDisplay
            }
            isImageSwatchDisabled={!isNewQVEnabled || isPickup ? isImageSwatchDisabled : false}
            isPDP={isPDP}
            isBundleProduct={isBundleProduct}
            isABTestLoaded={isABTestLoaded}
            onMouseOver={(e) => this.selectColourOnHover(e, isNewQVEnabled)}
            onFocus={(e) => this.selectColourOnHover(e, isNewQVEnabled)}
            onMouseLeave={selectColorToHoverOut}
            newColorList={newColorList}
            isNewQVEnabled={isNewQVEnabled}
            isPickup={isPickup}
            isNewPDPEnabled={isNewPDPEnabled}
            newQVDesign={isNewQVEnabled}
            primaryBrand={primaryBrand}
            fromBagPage={fromBagPage}
            alternateBrand={alternateBrand}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled && isPDP}
            departmentPillsEnabled={departmentPillsEnabled}
            isPDPRedesignEnabled={isPDPRedesignEnabled}
          />
        </div>
      )
    );
  };

  selectSwatch = (selectedswatch) => {
    const { departmentSwatches } = this.state;
    const data = departmentSwatches.find((swatch) => swatch.id === selectedswatch);
    const apiConfig = getAPIConfig();

    const {
      getDetails,
      alternateBrand,
      clearAddToBagError,
      resetProductDetailsDynamicData,
      isPlpPdpAnchoringEnabled,
      isNewPDPEnabled,
      trackClickWithoutDelay,
      setIsDeptClickedActn,
    } = this.props;
    const { pid = '', id = '' } = data;
    const category = id.split('_')[0].replace('Sizes', '');
    clearAddToBagError();
    resetProductDetailsDynamicData();
    setIsDeptClickedActn(true);
    getDetails({
      productColorId: pid,
      otherBrand: alternateBrand,
      isTakeDownClick: true,
      apiConfig,
      takeDownCategory: category,
    });
    trackClickWithoutDelay({
      color_consolidation_cd157: `${pid}|${category}`,
      color_consolidation_metrics104: '1',
      customEvents: ['event104'],
    });
    if (isPlpPdpAnchoringEnabled && isMobileWeb()) {
      scrollToBreadCrumb(false, isNewPDPEnabled);
    }
  };

  getImgSwatches = (departmentList) => {
    return (
      departmentList &&
      departmentList.map((dpt) => {
        return dpt.imagePath;
      })
    );
  };

  getImagesByColor = (departmentList) => {
    const imgByColor = {};
    departmentList?.forEach((dpt) => {
      imgByColor[dpt.id] = dpt.imagePath;
    });
    return imgByColor;
  };

  renderDepartmentSwatchList = (filteredSwatches) => {
    const departmentSwatchList = fromJS(filteredSwatches);
    const imageSwatchesToDisplay = this.getImgSwatches(filteredSwatches);
    const imagesByColor = this.getImagesByColor(filteredSwatches);
    const {
      showColorChips,
      isPDP,
      isLoading,
      isImageSwatchDisabled,
      isBundleProduct,
      setInitialQuickViewLoad,
      isABTestLoaded,
      isNewQVEnabled,
      isPickup,
      isNewPDPEnabled,
      primaryBrand,
      alternateBrand,
      fromBagPage,
      isNewPJPPDPRedesignEnabled,
    } = this.props;

    return this.skeletonCheck(isLoading, isPDP, setInitialQuickViewLoad) ? (
      <ProductDetailSectionSkeleton primaryBrand={primaryBrand} />
    ) : (
      showColorChips && departmentSwatchList?.size > 1 && (
        <div className="color-selector department-swatch">
          <Field
            width={87}
            id="department-swatch"
            name="DepartmentSwatch"
            component={ProductColorChipsSelector}
            colorFitsSizesMap={departmentSwatchList}
            onChange={this.selectSwatch}
            dataLocator="department-swatch"
            title=""
            imagesByColor={imagesByColor}
            imageSwatchesToDisplay={imageSwatchesToDisplay}
            isImageSwatchDisabled={!isNewQVEnabled || isPickup ? isImageSwatchDisabled : false}
            isPDP={isPDP}
            isBundleProduct={isBundleProduct}
            isABTestLoaded={isABTestLoaded}
            isNewQVEnabled={isNewQVEnabled}
            isNewPDPEnabled={isNewPDPEnabled}
            newQVDesign={isNewQVEnabled}
            primaryBrand={primaryBrand}
            fromBagPage={fromBagPage}
            alternateBrand={alternateBrand}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled && isPDP}
            isShowSelectedValueInLabel={false}
          />
        </div>
      )
    );
  };

  renderFitList = (fitList, fitTitle) => {
    const {
      selectFit,
      keepAlive,
      isStyleWith,
      isPDP,
      checkForOOSForVariant,
      isNewQVEnabled,
      isMultiItemQVModal,
      selectedFit,
      isUserPersonalizationEnabled,
      isOutfitPage,
      isPDPRedesignEnabled,
      checkForNewFits,
      currentProduct: { colorFitsSizesMap },
      selectedColor,
      isSplittingExtendedSizesEnabled,
      onNewFitClick,
    } = this.props;
    const newQVDesign = isNewQVEnabled;
    const newFitsCheck = checkForNewFits({
      colorFitsSizesMap,
      selectedColor,
      isSplittingExtendedSizesEnabled,
    });
    const handleFitChange = (e) => {
      if (e) {
        if (newFitsCheck) {
          onNewFitClick({ colorFitsSizesMap, selectedColor, selectedFit: e });
        } else {
          selectFit(e);
        }
      }
    };
    return this.productDetailSkeletonCheck() ? (
      <ProductDetailSectionSkeleton />
    ) : (
      fitList && fitList.size > 0 && (
        <div className={`fit-selector ${isStyleWith ? 'fit-selector-atb' : ''}`}>
          {!isStyleWith && (
            <Field
              width={69}
              id="fit"
              name="Fit"
              component={ProductSizeSelector}
              sizesMap={fitList}
              onChange={handleFitChange}
              dataLocator="addnewaddress-state"
              title={`${fitTitle}${newQVDesign && !isPDPRedesignEnabled ? '' : ':'}`}
              keepAlive={keepAlive}
              selectedFit={selectedFit}
              isPDP={isPDP}
              checkForOOSForVariant={checkForOOSForVariant}
              newQVDesign={newQVDesign}
              isMultiItemQVModal={isMultiItemQVModal}
              isFit
              fromFit={!isOutfitPage && !isMultiItemQVModal && isUserPersonalizationEnabled}
              isPDPRedesignEnabled={isPDPRedesignEnabled}
              newFitsCheck={newFitsCheck}
            />
          )}
          {isStyleWith && (
            <Field
              onChange={handleFitChange}
              placeholder="Select Fit"
              id="fit"
              name="Fit"
              component={SelectBox}
              dataLocator="fit-selector"
              options={fitList}
              className="field borderSelectBox"
              enableSuccessCheck={false}
              selectedFit={selectedFit}
              preText={`${fitTitle}${newQVDesign ? '' : ':'} `}
              forceSelect
              isPDP={isPDP}
              checkForOOSForVariant={checkForOOSForVariant}
              newFitsCheck={newFitsCheck}
            />
          )}
        </div>
      )
    );
  };

  selectDepartment = (filter) => {
    if (filter) {
      const { departmentSwatches } = this.state;

      const filteredSwatch = fetchFilteredSwatch(departmentSwatches, filter);

      this.setState({ filteredSwatches: filteredSwatch });
      this.selectSwatch(filteredSwatch[0].id);
    }
  };

  renderDepartmentList = (departments) => {
    const { isPDP, isNewQVEnabled, isPDPRedesignEnabled, initialValues } = this.props;
    const { departmentSwatches } = this.state;
    const selectedDepartment = initialValues?.Department;
    const updatedDepartments = departments?.map((dpt) => {
      const isDisabled = !departmentSwatches?.some((swatch) => {
        return swatch.id.split('_')[0] === dpt.id;
      });
      return { ...dpt, disabled: isDisabled };
    });
    const departmentList = fromJS(updatedDepartments);
    return this.productDetailSkeletonCheck() ? (
      <ProductDetailSectionSkeleton />
    ) : (
      departmentList && departmentList.size > 0 && (
        <div className="dmt-selector dmt-selector-atb">
          <Field
            width={69}
            id="department"
            name="Department"
            component={ProductSizeSelector}
            sizesMap={departmentList}
            onChange={this.selectDepartment}
            dataLocator="department-name"
            title={`Department${isNewQVEnabled && !isPDPRedesignEnabled ? '' : ':'}`}
            selectedFit={selectedDepartment}
            isPDP={isPDP}
            newQVDesign={isNewQVEnabled}
            isPDPRedesignEnabled={isPDPRedesignEnabled}
          />
        </div>
      )
    );
  };

  renderAlternateSizes = (alternateSizes) => {
    const { className, hideAlternateSizes, isLoading, isPDP, setInitialQuickViewLoad } = this.props;
    const sizeAvailable = renderLabel(
      this.pdpLabels.lbl_other_sizes_available,
      'lbl_other_sizes_available'
    );
    const visibleAlternateSizes =
      !hideAlternateSizes && alternateSizes && Object.keys(alternateSizes)?.length > 0;
    return isLoading && !isPDP && setInitialQuickViewLoad ? (
      <ProductDetailMoreSizeSkeleton />
    ) : (
      visibleAlternateSizes && (
        <AlternateSizes
          title={`${sizeAvailable}:`}
          buttonsList={alternateSizes}
          className={className}
        />
      )
    );
  };

  renderUnavailableLink = () => {
    const {
      currentProduct,
      currentProduct: { colorFitsSizesMap },
      onCloseClick,
      selectedColorProductId,
      keepAlive,
      isFromBagProductSfl,
      isPickup,
      isNewPDPEnabled,
      checkForOOSForVariant,
      accessoriesData,
      displayErrorMessage,
      selectedSize,
      formValues,
      isVMPBossEligible,
    } = this.props;
    let selectedSizeValue = selectedSize?.name;
    if (!selectedSizeValue && typeof formValues?.[0]?.size === 'string') {
      selectedSizeValue = formValues?.[0]?.size;
    }
    const sizeUnavailable =
      this.plpLabels && this.plpLabels.sizeUnavalaible ? this.plpLabels.sizeUnavalaible : '';
    const currentColorEntry = getMapSliceForColorProductId(
      colorFitsSizesMap,
      selectedColorProductId
    );
    const isAllSizeDisabled = this.checkIfAllSizeIsDisabled();
    return isFromBagProductSfl && isPickup ? (
      <ProductPickupContainer
        productInfo={currentProduct}
        formName={`ProductAddToBag-${currentProduct.generalProductId}`}
        isAnchor
        sizeUnavailable={sizeUnavailable}
        onPickupClickAddon={onCloseClick}
        miscInfo={currentColorEntry && currentColorEntry.miscInfo}
        keepAlive={keepAlive}
        quickViewLabels={this.quickViewLabels}
        isNewPDPEnabled={isNewPDPEnabled}
        checkForOOSForVariant={checkForOOSForVariant}
        isAllSizeDisabled={isAllSizeDisabled}
        accessoriesData={accessoriesData}
        selectedSizeValue={selectedSizeValue}
        displayErrorMessage={displayErrorMessage}
        isVMPBossEligible={isVMPBossEligible}
      />
    ) : null;
  };

  onChangeSize = (e, disabled) => {
    const {
      selectSize,
      // eslint-disable-next-line camelcase
      currentProduct: { categoryPathMap, categoryPath3_catMap },
      isMultiItemQVModal,
    } = this.props;

    if (!this.props.isOutfitPage && !isMultiItemQVModal) {
      // eslint-disable-next-line camelcase
      const categoryMap = categoryPathMap || categoryPath3_catMap;
      setUserSelection(categoryMap, { size: e });
    }

    this.isSizeSelected = true;
    selectSize(e, disabled);
  };

  isEnterKey = (e) => {
    return e?.keyCode === 13 || e?.key === 'Enter';
  };

  getSizeList = (sizeList, colorFitSizeDisplayNames, errorMessage, currentColorEntry) => {
    const {
      isErrorMessageDisplayed,
      isDisableZeroInventoryEntries,
      keepAlive,
      isSKUValidated,
      isStyleWith,
      isLoading,
      isPDP,
      checkForOOSForVariant,
      isNewQVEnabled,
      isNewPDPEnabled,
      addToPickupError,
      isMultiItemQVModal,
      selectSize,
      isAccessoriesEnabled,
      isPickup,
      isBopisPickupSelected,
      primaryBrand,
      isHardcodeSizeMapEnabled,
      hardcodeSizeMapConfig,
      isPickupPromotionPDPEnabled,
      isBopisSelected,
      isPDPRedesignEnabled,
      isStoreSpecialPriceEnabled,
    } = this.props;
    const { isPickUpSelected } = this.state;
    const newQVDesign = isNewQVEnabled;
    const isBopisEligible = this.getBopisAvailability(
      currentColorEntry,
      isStoreSpecialPriceEnabled
    );
    if (isStyleWith) {
      return (
        <Field
          onChange={
            isAccessoriesEnabled ? (e, disabled) => this.onChangeSize(e, disabled) : selectSize
          }
          placeholder="Select Size"
          name="Size"
          id="size"
          component={SelectBox}
          dataLocator="size-selector"
          options={sizeList}
          className="field borderSelectBox"
          enableSuccessCheck={false}
          preText={`${colorFitSizeDisplayNames.size}${
            isNewQVEnabled && !isPDPRedesignEnabled ? '' : ':'
          } `}
          forceSelect
          isPDPRedesignEnabled={isPDPRedesignEnabled}
        />
      );
    }
    // TODO: Replace checkForOOSForVariant={!isPickup ? checkForOOSForVariant : false}
    const isBOPIS = isPickUpSelected === DELIVERY_METHODS.BOPIS;

    return (
      <Field
        width={49}
        className={isErrorMessageDisplayed || isSKUValidated ? 'size-field-error' : 'size-field'}
        id="size"
        name="Size"
        component={ProductSizeSelector}
        sizesMap={sizeList}
        onChange={
          isAccessoriesEnabled ? (e, disabled) => this.onChangeSize(e, disabled) : selectSize
        }
        onKeyDown={(e) => {
          if (this.isEnterKey(e)) {
            selectSize(e);
          }
        }}
        dataLocator="addnewaddress-state"
        title={`${colorFitSizeDisplayNames.size}${
          isNewQVEnabled && !isPDPRedesignEnabled ? '' : ':'
        }`}
        isDisableZeroInventoryEntries={isDisableZeroInventoryEntries}
        keepAlive={keepAlive}
        isLoading={isLoading}
        isPDP={isPDP}
        checkForOOSForVariant={!isBOPIS ? checkForOOSForVariant : !isBopisEligible}
        newQVDesign={newQVDesign}
        isErrorMessageDisplayed={isErrorMessageDisplayed}
        errorMessage={errorMessage || addToPickupError}
        isNewPDPEnabled={isNewPDPEnabled}
        isSKUValidated={isSKUValidated}
        isPickUpSelected={isBopisEligible && isPickUpSelected === DELIVERY_METHODS.BOPIS}
        isMultiItemQVModal={isMultiItemQVModal}
        isPickup={isPickup}
        isBopisPickupSelected={isBopisPickupSelected}
        isSizeField
        primaryBrand={primaryBrand}
        isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
        hardcodeSizeMapConfig={hardcodeSizeMapConfig}
        isPickupPromotionPDPEnabled={isPickupPromotionPDPEnabled && isBopisSelected}
        isPDPRedesignEnabled={isPDPRedesignEnabled}
      />
    );
  };

  checkIfSizesAvailable = (sizeList) => sizeList && sizeList.size > 0;

  checkforProductDetailSkelton = (isLoading, isPDP, setInitialQuickViewLoad) => {
    return isLoading && !isPDP && setInitialQuickViewLoad;
  };

  newQVDesignCheck = (isNewQVEnabled, isPDP) => {
    return isNewQVEnabled && !isPDP;
  };

  atbPickupOrErrorCheck = (error1, error2) => {
    return error1 || error2;
  };

  checkStoreBopisAvailabilty = ({ sizeList }) => {
    const { isPickupPromotionPDPEnabled, isPDP, isBopisSelected } = this.props;
    if (isPDP && isBopisSelected && isPickupPromotionPDPEnabled) {
      const arr = [...sizeList];
      let tmpArr;
      if (arr[0] && typeof arr[0][Symbol.iterator] === 'function') {
        tmpArr = arr?.map((map) => Object.fromEntries(map));
      } else {
        tmpArr = arr;
      }
      return tmpArr.every((obj) => obj.softDisable === true);
    }
    return false;
  };

  renderSizeList = (
    sizeList,
    colorFitSizeDisplayNames,
    errorMessage,
    addToBagError,
    currentColorEntry
  ) => {
    const {
      sizeChartLinkVisibility,
      isErrorMessageDisplayed,
      sizeChartDetails,
      isLoading,
      isSKUValidated,
      isPDP,
      isStyleWith,
      setInitialQuickViewLoad,
      selectedFit,
      currentProduct: { categoryPath2Map },
      isNewQVEnabled,
      isNewPDPEnabled,
      isATBErrorMessageDisplayed,
      showAddToBagCTA,
      addToPickupError,
      colorList,
      isMultiItemQVModal,
      primaryBrand,
      alternateBrand,
      setPdpTabSectionName,
      isNewPJPPDPRedesignEnabled,
      imagesByColor,
    } = this.props;
    const imagesToDisplay =
      (imagesByColor &&
        getImagesToDisplay({
          imagesByColor,
          curentColorEntry: currentColorEntry,
          isAbTestActive: true,
          isFullSet: true,
        })) ||
      [];
    let dpr = `dpr_1.5`;
    const sizeChartImage =
      currentColorEntry &&
      currentColorEntry?.isLicensed &&
      imagesToDisplay?.find((img) => img.listingSizeImageUrl.includes('-sizechart'));
    const dprValue = isClient() && window && Math.floor(window.devicePixelRatio);
    if (dprValue === 2) {
      dpr = `dpr_1.5`;
    } else {
      dpr = dprValue ? `dpr_${dprValue}` : `dpr_1.5`;
    }
    const sizeChartImageURL = sizeChartImage
      ? `${getAssetHostURL()}/t_pdp_img_d,f_auto,q_auto,${dpr}/v1/ecom/assets/products/${getBrandName(
          primaryBrand,
          alternateBrand
        )}/${sizeChartImage.listingSizeImageUrl}`
      : '';
    const newQVDesign = this.newQVDesignCheck(isNewQVEnabled, isPDP);
    const singleColorSwatchClass = colorList?.length < 2 ? 'no-color-swatch' : '';
    const sizeChartProp = { sizeChart: this.plpLabels.sizeChart };
    return this.checkforProductDetailSkelton(isLoading, isPDP, setInitialQuickViewLoad) ? (
      <ProductDetailSectionSkeleton />
    ) : (
      this.checkIfSizesAvailable(sizeList) && (
        <div
          className={`size-selector ${singleColorSwatchClass} ${
            isStyleWith ? 'size-selector-atb' : ''
          }`}
        >
          {!isMultiItemQVModal &&
            newQVDesign &&
            sizeChartLinkVisibility === SIZE_CHART_LINK_POSITIONS.AFTER_SIZE && (
              <SizeChart
                sizeChartDetails={sizeChartDetails}
                labels={sizeChartProp}
                selectedFit={selectedFit}
                categoryPath2Map={categoryPath2Map}
                newQVDesign={newQVDesign}
                quickViewLabels={this.quickViewLabels}
                isNewPDPEnabled={isNewPDPEnabled}
                primaryBrand={primaryBrand}
                alternateBrand={alternateBrand}
                sizeChartImageURL={sizeChartImageURL}
              />
            )}
          {!newQVDesign &&
            !isNewPDPEnabled &&
            sizeChartLinkVisibility === SIZE_CHART_LINK_POSITIONS.AFTER_SIZE && (
              <SizeChart
                sizeChartDetails={sizeChartDetails}
                labels={{ sizeChart: this.plpLabels.sizeChart }}
                selectedFit={selectedFit}
                categoryPath2Map={categoryPath2Map}
                quickViewLabels={this.quickViewLabels}
                isNewPDPEnabled={isNewPDPEnabled}
                primaryBrand={primaryBrand}
                alternateBrand={alternateBrand}
                sizeChartImageURL={sizeChartImageURL}
              />
            )}

          {isPDP &&
            isNewPDPEnabled &&
            sizeChartLinkVisibility === SIZE_CHART_LINK_POSITIONS.AFTER_SIZE && (
              <SizeChart
                sizeChartDetails={sizeChartDetails}
                labels={{ sizeChart: this.plpLabels.sizeChart }}
                selectedFit={selectedFit}
                categoryPath2Map={categoryPath2Map}
                newQVDesign={newQVDesign}
                quickViewLabels={this.quickViewLabels}
                isNewPDPEnabled={isNewPDPEnabled}
                primaryBrand={primaryBrand}
                alternateBrand={alternateBrand}
                setPdpTabSectionName={setPdpTabSectionName}
                isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                isPDP
                sizeChartImageURL={sizeChartImageURL}
              />
            )}

          {this.getSizeList(
            sizeList,
            colorFitSizeDisplayNames,
            this.atbPickupOrErrorCheck(errorMessage, addToPickupError),
            currentColorEntry
          )}
          {(isNewQVEnabled || !isNewQVEnabled || isNewPDPEnabled) && !isMultiItemQVModal && (
            <div className="please-enter-an-error">
              {!addToPickupError &&
                this.atbPickupOrErrorCheck(isErrorMessageDisplayed, isSKUValidated) &&
                ErrorComp(
                  this.checkStoreBopisAvailabilty({ sizeList })
                    ? this.nearBylabel
                    : this.atbPickupOrErrorCheck(errorMessage, addToPickupError)
                )}
            </div>
          )}
          {isNewPDPEnabled && !isMultiItemQVModal ? (
            <div className="please-enter-an-error">
              {(isATBErrorMessageDisplayed || addToPickupError) &&
                ErrorComp(
                  this.atbPickupOrErrorCheck(addToBagError, addToPickupError),
                  showAddToBagCTA
                )}
            </div>
          ) : null}
        </div>
      )
    );
  };

  quantityChange = (e, v) => {
    const { onQuantityChange, displayErrorMessage } = this.props;
    displayErrorMessage(false);
    onQuantityChange(v);
  };

  renderQuantitySelector = () => {
    const {
      isFromBagProductSfl,
      quantityList,
      isLoading,
      isPDP,
      keepAlive,
      setInitialQuickViewLoad,
      sizeChartLinkVisibility,
      sizeChartDetails,
      selectedFit,
      currentProduct: { categoryPath2Map },
      isNewQVEnabled,
      isNewPDPEnabled,
      fromBagPage,
      isBossPickupEdit,
      productInfoFromBag,
      isMultiItemQVModal,
      isShowDeleteIconInBag,
      isBundleProduct,
      isSocialProofOnAtbButtonEnabled,
    } = this.props;
    const newQVDesign = isNewQVEnabled;
    const qtyFrombag = productInfoFromBag?.Quantity;
    const socialProofMessage = this.getSocialProofMsg();
    const socialProofMessageCheck =
      !isNewPDPEnabled &&
      isPDP &&
      !this.isMobile &&
      socialProofMessage?.variation === 'bottom' &&
      !isSocialProofOnAtbButtonEnabled;
    buttonIndex += 1;
    return isLoading && !isPDP && setInitialQuickViewLoad ? (
      <ProductDetailSectionSkeleton />
    ) : (
      !isFromBagProductSfl && (
        <div className={`${socialProofMessageCheck ? 'social-proof-wrapper-qty' : ''}`}>
          <div
            className={`${newQVDesign ? 'qty-selector-qv' : 'qty-selector'} ${
              socialProofMessageCheck ? 'socialProof' : ''
            }`}
          >
            <Field
              width={32}
              id={`${newQVDesign ? `quantity-new-qv -${buttonIndex}` : `quantity -${buttonIndex}`}`}
              name="Quantity"
              component={MiniBagSelect}
              options={quantityList}
              onChange={this.quantityChange}
              dataLocator="addnewaddress-state"
              keepAlive={keepAlive}
              newQVDesign={newQVDesign}
              sizeChartLinkVisibility={sizeChartLinkVisibility}
              sizeChartDetails={sizeChartDetails}
              selectedFit={selectedFit}
              categoryPath2Map={categoryPath2Map}
              quickViewLabels={this.quickViewLabels}
              isNewPDPEnabled={isNewPDPEnabled}
              fromBagPage={fromBagPage}
              isQuantitySection
              isBossPickupEdit={isBossPickupEdit}
              qtyFrombag={qtyFrombag}
              isBundleProduct={isBundleProduct}
              isBagDeletionEnabled={
                isShowDeleteIconInBag &&
                !isMultiItemQVModal &&
                fromBagPage &&
                !productInfoFromBag?.includesAccessory
              }
              removeCartItem={this.removeCartItem}
            />
          </div>
          {socialProofMessageCheck && (
            <SocialProofMessage socialProofMessage={socialProofMessage} />
          )}
        </div>
      )
    );
  };

  isSelectedProductCTA = () => {
    const { currentProduct, showAddedToBagCta, generalProductId } = this.props;
    const { productId, unbxdProdId } = currentProduct || {};
    return (
      (showAddedToBagCta && showAddedToBagCta === generalProductId) ||
      showAddedToBagCta === productId ||
      showAddedToBagCta === unbxdProdId
    );
  };

  showAddedToBagCTA = (
    isProductCTA,
    addBtnMsg,
    outfitCarouselState,
    isEnabledOutfitAddedCTA,
    isPDPAddedToBag
  ) =>
    isProductCTA &&
    addBtnMsg &&
    !outfitCarouselState &&
    (isEnabledOutfitAddedCTA || isPDPAddedToBag);

  addedToMsgWrapper = (sticky) => {
    const {
      addBtnMsg,
      hasLoyaltyAbTestFlag,
      outfitCarouselState,
      showAddtoBagDrawer,
      isPDP,
      isEnabledOutfitAddedCTA,
      isNewPDPEnabled,
    } = this.props;
    const isPDPAddedToBag = (isPDP && showAddtoBagDrawer) || hasLoyaltyAbTestFlag;
    const showAddedCTA = this.showAddedToBagCTA(
      this.isSelectedProductCTA(),
      addBtnMsg,
      outfitCarouselState,
      isEnabledOutfitAddedCTA,
      isPDPAddedToBag
    );
    return (
      <>
        {showAddedCTA && !isNewPDPEnabled && (
          <Button
            className={`add-to-bag-button ${sticky ? 'added-to-bag-sticky' : 'added-to-bag'}`}
          >
            <div className="check" />
            {this.addedToBagLabel}
          </Button>
        )}
        {addBtnMsg && !outfitCarouselState && this.addedToBagMsgAction()}
      </>
    );
  };

  addedToMsgWrapperOutfit = () => {
    const { showOutfitCarouselAddedCTA, isNewPDPEnabled } = this.props;
    return (
      <>
        {showOutfitCarouselAddedCTA && !isNewPDPEnabled && (
          <Button className="add-to-bag-button added-to-bag">
            <div className="check" />
            {this.addedToBagLabel}
          </Button>
        )}
        {showOutfitCarouselAddedCTA && this.addedToBagMsgAction(true)}
      </>
    );
  };

  addedToBagMsgAction = (isOutfit = false) => {
    const { addedTobagMsgDispatch, outfitCarouselAddedToBagMsgDispatch } = this.props;
    const bagMsgDispatchTimeout = setTimeout(() => {
      if (isOutfit) {
        outfitCarouselAddedToBagMsgDispatch(false);
      } else {
        addedTobagMsgDispatch(false);
      }
      clearTimeout(bagMsgDispatchTimeout);
    }, 2000);
  };

  getColor = (product, selectedColorProductId) => {
    return (
      (product &&
        product.colorFitsSizesMap &&
        product.colorFitsSizesMap
          ?.filter((productTile) => {
            return productTile.colorDisplayId === selectedColorProductId;
          })
          .map((productTile) => productTile.color.name)
          .join('')) ||
      ''
    );
  };

  getProdCategory = (category) => {
    let prodCategory = '';
    if (category === 'accessories') {
      prodCategory = 'accessories';
    } else if (category === 'shoes') {
      prodCategory = 'shoes';
    } else {
      prodCategory = 'apparel';
    }
    return prodCategory;
  };

  getTrackProps = (props) => {
    const {
      currentProduct = {},
      selectedSize = {},
      selectedFit,
      selectedColor = {},
      pageData,
      itemBrand,
      currency,
      isPDP,
      isOutfitPage,
    } = props;
    const {
      generalProductId,
      name,
      offerPrice,
      listPrice,
      colorFitsSizesMap,
      reviewsCount,
      ratings,
      isGiftCard,
      productId,
    } = currentProduct;
    const originPage = getSessionStorage('LAST_PAGE_PATH') || '';
    const { categoryId, categoryPathMap: categoryPathing } = currentProduct;
    const exactCategoryPath =
      categoryPathing && categoryPathing?.filter((category) => category.includes(categoryId));
    const categoryIdAndName = exactCategoryPath && getCategoryIdAndName(exactCategoryPath);
    const prodId = generalProductId && generalProductId.split('_')[0];
    const productName = name && name.toLowerCase();
    let trackingCategories = {};
    const { pageName = '' } = pageData || {};
    const [pageType, departmentList, categoryList, listingSubCategory] = pageName.split(':');
    if (pageType === 'browse') {
      trackingCategories = {
        departmentList,
        categoryList,
        listingSubCategory,
      };
    }

    const addToBagTrackProduct = {
      id: prodId,
      colorId: generalProductId,
      brand: itemBrand,
      name: productName,
      price: offerPrice,
      CurrCurrency: currency,
      listPrice,
      prodColor: this.getColor(currentProduct, generalProductId),
      extPrice: listPrice,
      pricingState: offerPrice < listPrice ? 'on sale' : 'full price',
      size: selectedSize.name,
      sku: getSkuId(colorFitsSizesMap, selectedColor.name, selectedFit, selectedSize.name),
      reviews: reviewsCount,
      rating: ratings,
      productFeatures: getFeatures(colorFitsSizesMap, generalProductId, isGiftCard),
      fromPDP: isPDP,
      fromPageName: isClient() ? getGAPageName(window.location.pathname) : '',
      isOutfitPage,
      ...addRecommendationsObj(productId),
    };
    if (originPage.includes('/search') || categoryId) {
      if (originPage.includes('/search')) {
        const searchQuery = originPage.split('/');
        const searchTerm = (searchQuery && searchQuery[searchQuery?.length - 1]) || '';
        addToBagTrackProduct.searchTerm = searchTerm;
      } else {
        addToBagTrackProduct.categoryId = categoryIdAndName || currentProduct.categoryId || '';
        addToBagTrackProduct.category = categoryIdAndName || currentProduct.categoryId || '';
      }
    }
    return {
      addToBagTrackProduct,
      pageShortName: productId ? `product:${productId}:${productName}` : '',
      productId,
      outfitPageShortName: productId ? `outfit:${productId}:${productName}` : '',
      trackingCategories,
    };
  };

  scrollIntoView = () => {
    const { isStickyAtbHeader } = this.props;

    const errorDiv =
      isSafariBrowser() && !(isStickyAtbHeader && this.getIsValidPdpPage())
        ? document.getElementsByClassName('product-summary-wrapper')[0]
        : document.getElementsByClassName('please-enter-an-error')[0];
    const { isMobile } = getViewportInfo() || {};
    if (errorDiv && (isMobile || isStickyAtbHeader))
      errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  revertAddedToBagAction = async () => {
    const {
      revertCarouselAtbButton,
      showAddedToBagCta,
      outfitCarouselState,
      revertAtbButton,
      showOutfitCarouselAddedCTA,
    } = this.props;
    if (showAddedToBagCta && !outfitCarouselState) {
      revertAtbButton();
    }
    if (showOutfitCarouselAddedCTA) {
      revertCarouselAtbButton();
    }
  };

  getProductId = (products) => {
    return products && products?.length && products[0].sku;
  };

  checkIfSizeIsDisabled = () => {
    const { selectedSize, sizeList, fromBagPage } = this.props;
    const selectedSizeValue = fromBagPage ? { name: this.getSelecterSizeValue() } : selectedSize;
    if (selectedSizeValue) {
      const isSizeAvailable = sizeList
        ? sizeList.some((sizeItem) => {
            return (sizeItem && sizeItem.displayName) === selectedSizeValue.name;
          })
        : false;
      if (!isSizeAvailable) {
        return true;
      }
    }
    const disabledSizeArray = sizeList
      ? sizeList.filter((sizeItem) => {
          return (
            (sizeItem && sizeItem.displayName) === (selectedSize && selectedSize.name) &&
            sizeItem &&
            sizeItem.disabled
          );
        })
      : [];
    return disabledSizeArray && disabledSizeArray?.length > 0;
  };

  checkIfAllSizeIsDisabled = () => {
    const { sizeList } = this.props;
    const disabledSizeArray = sizeList
      ? sizeList.filter((sizeItem) => {
          return sizeItem?.disabled === false;
        })
      : [];
    return disabledSizeArray && disabledSizeArray?.length === 0;
  };

  showInStoreMsgFunc = () => {
    const { sizeList, selectedSize, isPickupPromotionPDPEnabled } = this.props;
    if (!sizeList || !selectedSize || !isPickupPromotionPDPEnabled) return false; // Return early if no props are present
    const { name } = selectedSize;
    const matchingSize = sizeList.find((size) => size.displayName === name);
    return matchingSize ? matchingSize.showInStoreMsg : false;
  };

  renderFulFilmentSection = (
    isMultiItemQVModal,
    fromBagPage,
    product,
    currentColorEntry,
    isFavoriteEdit,
    className,
    {
      itemBrand,
      availableTCPmapNewStyleId,
      initialMultipackMapping,
      setInitialTCPStyleQty,
      fromPage,
    }
  ) => {
    const {
      isNewQVEnabled,
      productInfoFromBag,
      pdpUrlFromBag,
      onCloseClick,
      isNewPDPEnabled,
      isPickup,
      checkForOOSForVariant,
      alternateBrandFromUrl,
      accessoriesData,
      displayErrorMessage,
      isVMPBossEligible,
      isPDP,
      isNewPJPPDPRedesignEnabled,
      fitChanged,
      isQuickView,
      sizeList,
      isBopisSelected,
      isPickUpSelectedState,
      partIdInfo,
      getAllNewMultiPack,
      multipackProduct,
      multiPackCount,
      setMethod,
      storeSpecials,
      loyaltyTierBenefits,
      isLoyaltyTierEnabled,
    } = this.props;
    const { isPickUpSelected } = this.state;
    const { isGiftCard } = product;
    const isAllSizeDisabled = this.checkIfAllSizeIsDisabled();
    const selectedSizeValue = this.getSelecterSizeValue();
    const selectedFitValue = this.getSelecterFitValue();
    const showInStoreMsg = this.showInStoreMsgFunc();
    const earlyAccessAvailability = this.getEarlyAccessAvailability();
    const isFutureDate = new Date(earlyAccessAvailability) > new Date();
    const isAvailable = this.isProductAvailableForAccessHours(
      earlyAccessAvailability,
      loyaltyTierBenefits
    );
    const disableBtn = isLoyaltyTierEnabled && isFutureDate && !isAvailable;

    let isDisabledSizeSelected = null;
    try {
      const updatedSizeList = sizeList ? JSON.parse(JSON.stringify(sizeList)) : [];
      if (
        (isPickup && isPickUpSelectedState === 'bopis') ||
        isBopisSelected ||
        isPickUpSelected === 'bopis'
      ) {
        isDisabledSizeSelected = updatedSizeList?.filter(
          (size) => size?.displayName === selectedSizeValue
        );
      } else {
        isDisabledSizeSelected = updatedSizeList?.filter(
          (size) => size?.displayName === selectedSizeValue && !size?.disabled
        );
      }
    } catch {
      logger.log('Error Parsing-----size error in ProductAddTobag.view');
    }

    const shouldShowSizeError =
      ((fitChanged && selectedFitValue) || selectedFitValue || selectedFitValue === undefined) &&
      Array.isArray(isDisabledSizeSelected) &&
      isDisabledSizeSelected?.length === 0;
    return (
      !isMultiItemQVModal &&
      !isFavoriteEdit &&
      product &&
      currentColorEntry &&
      fromPage !== 'fromPDPAccessories' &&
      fromPage !== 'fromQVAccessories' && (
        <BodyCopy
          component="div"
          className={`${className} fulfillment-section-wrapper ${
            isNewQVEnabled ? this.quickViewDrawerClass : ''
          } ${isGiftCard ? 'gift-card-new-pdp' : ''} `}
        >
          <ProductPickupContainer
            productInfo={product}
            itemBrand={itemBrand}
            formName={`ProductAddToBag-${product.generalProductId}`}
            miscInfo={currentColorEntry.miscInfo}
            onPickupClickAddon={() => onCloseClick(true)}
            availableTCPmapNewStyleId={availableTCPmapNewStyleId}
            initialMultipackMapping={initialMultipackMapping}
            setInitialTCPStyleQty={setInitialTCPStyleQty}
            isNewQVEnabled={isNewQVEnabled && !isPickup}
            currentColorEntry={currentColorEntry}
            productInfoFromBag={productInfoFromBag}
            fromBagPage={fromBagPage}
            pdpUrlFromBag={pdpUrlFromBag}
            onCloseClick={() => onCloseClick(true)}
            quickViewLabels={this.quickViewLabels}
            pickupSelectionUpdate={this.pickupSelectionUpdate}
            isPickUpSelected={isPickUpSelected}
            isNewPDPEnabled={isNewPDPEnabled}
            checkForOOSForVariant={checkForOOSForVariant}
            alternateBrand={alternateBrandFromUrl}
            isAllSizeDisabled={isAllSizeDisabled}
            accessoriesData={accessoriesData}
            selectedSizeValue={selectedSizeValue}
            displayErrorMessage={displayErrorMessage}
            isVMPBossEligible={isVMPBossEligible}
            isPDP={isPDP}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            shouldShowSizeError={shouldShowSizeError === undefined ? true : shouldShowSizeError}
            isQuickView={isQuickView}
            partIdInfo={partIdInfo}
            getAllNewMultiPack={getAllNewMultiPack}
            multipackProduct={multipackProduct}
            multiPackCount={multiPackCount}
            showInStoreMsg={showInStoreMsg}
            isAllSizeDisableForBopisStore={this.checkStoreBopisAvailabilty({ sizeList })}
            setMethod={setMethod}
            storeSpecials={storeSpecials}
            earlyAccessDisable={disableBtn}
          />
        </BodyCopy>
      )
    );
  };

  getSelecterSizeValue = () => {
    const {
      selectedSize,
      formValues,
      isUserPersonalizationEnabled,
      isOutfitPage,
      isMultiItemQVModal,
    } = this.props;
    const updatedForm = Array.isArray(formValues) ? formValues[0] : formValues;
    let selectedSizeValue =
      typeof updatedForm?.size === 'string' ? updatedForm?.size : selectedSize?.name;
    const sizeListArray = this.props.sizeList;
    if (
      !isOutfitPage &&
      !isMultiItemQVModal &&
      isUserPersonalizationEnabled &&
      sizeListArray &&
      sizeListArray.length > 0
    ) {
      let idx = 0;
      idx = sizeListArray.findIndex(
        (sizeListItem) => sizeListItem.displayName === selectedSizeValue
      );
      if (idx < 0) {
        selectedSizeValue = null;
      }
    }
    return selectedSizeValue;
  };

  getSelecterFitValue = () => {
    const { selectedFit, formValues } = this.props;
    const updatedForm = Array.isArray(formValues) ? formValues[0] : formValues;
    let selectedFitValue = selectedFit?.name;
    if (!selectedFitValue && typeof updatedForm?.fit === 'string') {
      selectedFitValue = updatedForm?.fit;
    }
    return selectedFitValue;
  };

  getButtonFill = () => {
    const { addedToBagBtnLoader } = this.props;
    if (addedToBagBtnLoader) return 'WHITE';
    return isPJP() ? 'PJP_PRIMARY' : '';
  };

  renderAddToBagButton = (uniqueKeyId, analyticsData, className) => {
    const {
      fitChanged,
      displayErrorMessage,
      handleFormSubmit,
      keepAlive,
      isLoading,
      setAnalyticsData,
      checkForOOSForVariant,
      isNewQVEnabled,
      isPDP,
      isNewPDPEnabled,
      selectedAccessories = [],
      accessoriesData,
      fromPage,
      accessoriesDataQV,
      displayAccessoriesErrorMessage,
      isAccessoriesEnabled,
      fromBagPage,
      tempSecondarySelectedAccessoryList,
      TCPStyleType = '',
      productInfoFromBag,
      isErrorMessageDisplayed,
      isOutfitPage,
      currentProduct,
      isUserPersonalizationEnabled,
      isMultiItemQVModal,
      isBossPickupEdit,
      addedToBagBtnLoader,
      isSocialProofOnAtbButtonEnabled,
      isLoyaltyTierEnabled,
      loyaltyTierBenefits,
    } = this.props;
    const { hasMounted, showAddedText } = this.state;
    const { accessorySelected } = this.plpLabels;
    const { customizationType } = accessoriesData || {};
    const { product } = (accessoriesDataQV && accessoriesDataQV[0]) || {};
    const QVAccessoriesData = product && product.accessoriesData;
    const QVAccessoriesCustomizationType = QVAccessoriesData?.customizationType || '';
    const isSizeDisabled = this.checkIfSizeIsDisabled();
    const selectedSizeValue = this.getSelecterSizeValue();
    const selectedFitValue = this.getSelecterFitValue();
    const categoryMap = currentProduct.categoryPathMap || currentProduct.categoryPath3_catMap;
    const stickyBtn = this.renderStickyATCButton();
    const socialProofMessage = this.getSocialProofMsg();
    const socialProofMessageCheck =
      !isNewPDPEnabled &&
      this.isMobile &&
      isPDP &&
      socialProofMessage?.variation === 'bottom' &&
      !isSocialProofOnAtbButtonEnabled;
    const secondaryAccessorySelected =
      product &&
      tempSecondarySelectedAccessoryList &&
      tempSecondarySelectedAccessoryList?.filter(
        (accessory) => accessory.parentProductId === product.generalProductId
      );

    const shouldDisableAddCta =
      !(fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') &&
      TCPStyleType === '0007';
    buttonIndex += 1;
    const { disableQuantityEdit = false } = productInfoFromBag || {};
    const isSocialProofMessageAvailable = socialProofMessage?.priorityMsg?.length > 0 && isPDP;
    const earlyAccessAvailability = this.getEarlyAccessAvailability();
    const isFutureDate = new Date(earlyAccessAvailability) > new Date();
    const isAvailable = this.isProductAvailableForAccessHours(
      earlyAccessAvailability,
      loyaltyTierBenefits
    );
    const disableBtn = isLoyaltyTierEnabled && isFutureDate && !isAvailable;

    return (
      <div
        className={`${isNewPDPEnabled || isNewQVEnabled ? 'pdp-redesign-wrapper' : ''} ${
          socialProofMessageCheck ? 'social-proof-message-atb' : ''
        } ${this.renderButtonOrAccessorySelected() ? 'accessory-selected' : ''}`}
      >
        {socialProofMessageCheck ? (
          <SocialProofMessage socialProofMessage={socialProofMessage} />
        ) : null}
        {hasMounted &&
          (isNewQVEnabled || isNewPDPEnabled) &&
          fromPage !== 'fromPDPAccessories' &&
          fromPage !== 'fromQVAccessories' &&
          !disableQuantityEdit && <div className="new-pdp-qty-selector">{this.qtySelector()}</div>}
        {this.renderButtonOrAccessorySelected() ? (
          <BodyCopy
            component="p"
            fontSize={['fs15', 'fs16', 'fs16']}
            color="blue.900"
            fontFamily="secondary"
            fontWeight="extrabold"
          >
            {accessorySelected}
          </BodyCopy>
        ) : (
          <TireDynamicButton
            type="submit"
            uniqueKey={uniqueKeyId}
            className={`${className} ${isNewQVEnabled ? this.quickViewDrawerClass : ''} atb-button${
              addedToBagBtnLoader ? ' add-to-bag-button-loader' : ''
            } ${
              isSocialProofOnAtbButtonEnabled && isSocialProofMessageAvailable
                ? 'social-proofing-msg-on-atb-button'
                : ''
            }`}
            buttonVariation="variable-width"
            id={`brand-${getBrand()} -${buttonIndex}`}
            disabled={
              !isLoading
                ? keepAlive ||
                  checkForOOSForVariant ||
                  this.checkIfAllSizeIsDisabled() ||
                  shouldDisableAddCta ||
                  disableBtn
                : isLoading
            }
            fill={this.getButtonFill()}
            onClick={(e) => {
              e.preventDefault();
              setTimeout(async () => {
                if (isBossPickupEdit) {
                  this.scrollIntoView();
                }
                await AddedtoBagDynamicStore();
                if (
                  (isUserPersonalizationEnabled &&
                    (!selectedSizeValue || selectedSizeValue === '')) ||
                  (!isUserPersonalizationEnabled && (fitChanged || !selectedSizeValue)) ||
                  isSizeDisabled ||
                  (isAccessoriesEnabled &&
                    !fromBagPage &&
                    ((customizationType === 'mandatory' &&
                      fromPage !== 'fromPDPAccessories' &&
                      fromPage !== 'fromQVAccessories') ||
                      QVAccessoriesCustomizationType === 'mandatory') &&
                    (selectedAccessories?.length < 1 ||
                      (this.isSecondaryAccessories && secondaryAccessorySelected?.length < 1)) &&
                    !(
                      QVAccessoriesCustomizationType === 'mandatory' &&
                      secondaryAccessorySelected &&
                      secondaryAccessorySelected?.length
                    ))
                ) {
                  if (fitChanged || !selectedSizeValue || isSizeDisabled) {
                    displayErrorMessage(true);
                  }
                  displayAccessoriesErrorMessage(
                    this.isSecondaryAccessories ? secondaryAccessorySelected : selectedAccessories
                  );

                  if (
                    !isOutfitPage &&
                    isAccessoriesEnabled &&
                    (isErrorMessageDisplayed || fitChanged || !selectedSizeValue || isSizeDisabled)
                  ) {
                    const form = e?.target?.form;
                    if (form) {
                      const headingElem = form.querySelector('.select-value-wrapper');
                      if (headingElem) {
                        const timer = setTimeout(() => {
                          headingElem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                          clearTimeout(timer);
                        }, 250);
                      }
                    }
                  }
                  if (stickyBtn) this.scrollIntoView();
                } else {
                  if (!isOutfitPage && !isMultiItemQVModal) {
                    setUserSelection(
                      categoryMap,
                      {
                        fit: selectedFitValue,
                        size: selectedSizeValue,
                      },
                      true
                    );
                  }

                  handleFormSubmit();
                }
                setAnalyticsData(analyticsData);
              }, 0);
            }}
            isTireLabel={isLoyaltyTierEnabled && isFutureDate && !isAvailable}
          >
            {addedToBagBtnLoader && (
              <Image
                className="check-icon-outfits"
                width="20px"
                height="20px"
                src={getIconPath('circle-check-form-icon')}
                alt="reward-icon"
                aria-hidden="true"
              />
            )}
            {addedToBagBtnLoader ? showAddedText && 'Added' : this.getButtonLabel()}
            {isSocialProofOnAtbButtonEnabled && isSocialProofMessageAvailable && (
              <SocialProofMessage
                socialProofMessage={socialProofMessage}
                socialProofAtbMessage={!!socialProofMessage}
              />
            )}
          </TireDynamicButton>
        )}
      </div>
    );
  };

  getAddToBagOutfitCarouselButton = (uniqueKeyId, analyticsData, className) => {
    const { isLoading, isPDP, showOutfitCarouselAddedCTA, setInitialQuickViewLoad } = this.props;
    if (isLoading && !isPDP && setInitialQuickViewLoad) {
      return <ProductDetailSectionSkeleton />;
    }
    return !showOutfitCarouselAddedCTA ? (
      this.renderAddToBagButton(uniqueKeyId, analyticsData, className)
    ) : (
      <></>
    );
  };

  getAddToBagButton = (uniqueKeyId, analyticsData, className) => {
    const { isLoading, isPDP, addBtnMsg, setInitialQuickViewLoad } = this.props;
    if (isLoading && !isPDP && setInitialQuickViewLoad) {
      return <ProductDetailSectionSkeleton />;
    }
    return !addBtnMsg || !this.isSelectedProductCTA() ? (
      this.renderAddToBagButton(uniqueKeyId, analyticsData, className)
    ) : (
      <></>
    );
  };

  getAddToBagButtonAction = (uniqueKeyId, clickDataAnalytics, className) => {
    const { isOutfitCarousel } = this.props;
    return !isOutfitCarousel
      ? this.getAddToBagButton(uniqueKeyId, clickDataAnalytics, className)
      : this.getAddToBagOutfitCarouselButton(uniqueKeyId, clickDataAnalytics, className);
  };

  getIsValidPdpPage = () => {
    const { isOutfitPage, keepAlive, isBundleProduct, isPDP } = this.props;
    return isPDP && !isBundleProduct && !isOutfitPage && !keepAlive;
  };

  shouldRenderStickyButton = () => {
    const { hideStickyABTest, isStickyAtbHeader } = this.props;
    return !hideStickyABTest && !isStickyAtbHeader && this.getIsValidPdpPage();
  };

  shouldRenderStickyHeader = (isPickupActive, fromScroll) => {
    const { isStickyAtbHeader } = this.props;
    const { showStickyATC, showStickyPickUp } = this.state;

    return (
      (isStickyAtbHeader &&
        this.getIsValidPdpPage() &&
        ((showStickyATC && !isPickupActive) ||
          (showStickyPickUp && isPickupActive) ||
          fromScroll)) ||
      false
    );
  };

  renderStickyATCButton = (fromScroll) => {
    const { showStickyATC } = this.state;
    return (this.shouldRenderStickyButton() && (fromScroll || showStickyATC)) || false;
  };

  renderStickyPickUp = (fromScroll) => {
    const { showStickyPickUp } = this.state;
    return (this.shouldRenderStickyButton() && (fromScroll || showStickyPickUp)) || false;
  };

  selectedVal = (setInitialTCPStyleQty, TCPStyleQTY) => {
    const { fromBagPage } = this.props;
    return !fromBagPage && parseInt(setInitialTCPStyleQty, 10)
      ? setInitialTCPStyleQty
      : TCPStyleQTY;
  };

  getToolTipDirection = (isDisabled, isPillSelected) => {
    if (isDisabled && !isPillSelected && !this.isMobile && !this.isTablet) {
      return 'center-for-mpack';
    }
    return '';
  };

  isMultipackSelected = (item, multipackToSelect) => {
    return item === multipackToSelect;
  };

  renderPillsWithToolTip = (params) => {
    const {
      item,
      multipackToSelect,
      mpackBg,
      direction,
      isDisabled,
      index,
      singlePack,
      getToolTipLabel,
      newQVDesign,
      disableSwappingMpackPills,
      softDisablePill,
    } = params;
    return (
      <ReactTooltip
        fontFamily="secondary"
        message={getToolTipLabel}
        minWidth="179px"
        direction={direction}
      >
        <BodyCopy
          component="li"
          key={item}
          className={item === multipackToSelect ? `${mpackBg}-wrapper` : null}
        >
          <button
            className={`${disableSwappingMpackPills ? 'mpack-btn' : 'mpack-btn-swap'} ${
              newQVDesign ? this.quickViewDrawerClass : ''
            } ${softDisablePill} ${item === multipackToSelect ? `${mpackBg} ` : ''}`}
            onClick={(e) => this.onClickMultipackBtn(e, index, item, singlePack)}
            disabled={isDisabled}
            aria-label={`${
              item !== singlePack
                ? `${item} ${this.pdpLabels && this.pdpLabels.lbl_multipack_pack_text}`
                : item
            } ${this.isMultipackSelected(item, multipackToSelect) ? 'Selected' : 'Not selected'}`}
          >
            {item}
            {item !== singlePack
              ? this.pdpLabels &&
                renderLabel(this.pdpLabels.lbl_multipack_pack_text, 'lbl_multipack_pack_text')
              : ''}
          </button>
        </BodyCopy>
      </ReactTooltip>
    );
  };

  renderPillsWithoutToolTip = (params) => {
    const {
      item,
      multipackToSelect,
      mpackBg,
      disableSwappingMpackPills,
      softDisablePill,
      index,
      singlePack,
      isDisabled,
      newQVDesign,
    } = params;

    return (
      <BodyCopy
        component="li"
        key={item}
        className={item === multipackToSelect ? `${mpackBg}-wrapper` : null}
      >
        <button
          className={`${disableSwappingMpackPills ? 'mpack-btn' : 'mpack-btn-swap'} ${
            newQVDesign ? this.quickViewDrawerClass : ''
          } ${softDisablePill} ${item === multipackToSelect ? `${mpackBg} ` : ''}`}
          onClick={(e) => this.onClickMultipackBtn(e, index, item, singlePack)}
          disabled={isDisabled}
          aria-label={`${
            item !== singlePack
              ? `${item} ${this.pdpLabels && this.pdpLabels.lbl_multipack_pack_text}`
              : item
          } ${this.isMultipackSelected(item, multipackToSelect) ? 'Selected' : 'Not selected'}`}
        >
          {item}
          {item !== singlePack
            ? this.pdpLabels &&
              renderLabel(this.pdpLabels.lbl_multipack_pack_text, 'lbl_multipack_pack_text')
            : ''}
        </button>
      </BodyCopy>
    );
  };

  MultipackButton = ({
    item,
    multipackToSelect,
    singlePack,
    index,
    disableMultiPackTab,
    selectedMultipack,
    softDisableMutiPack,
    disableSwappingMpackPills,
    mpackBg,
    newQVDesign,
  }) => {
    const selectedMultiPackVal = Number(selectedMultipack) === 1 ? item : selectedMultipack;
    const softClass = softDisableMutiPack ? [...new Set(getSoftClass(softDisableMutiPack))] : [];
    const getSingleKey = this.pdpLabels && this.pdpLabels.lbl_multipack_single_text;
    const getToolTipLabel = renderLabel(
      this.pdpLabels.lbl_unavailable_color,
      'lbl_unavailable_color'
    );
    const softDisablePill = checkAvailablePill(item, softClass, multipackToSelect, getSingleKey);
    const isDisabled = disableMultiPackTab && item === selectedMultiPackVal;
    const direction = this.getToolTipDirection(
      softDisablePill === 'soft-disable',
      item === multipackToSelect
    );
    const { hasMounted } = this.state;
    return hasMounted && disableSwappingMpackPills && direction !== ''
      ? this.renderPillsWithToolTip({
          item,
          multipackToSelect,
          mpackBg,
          direction,
          isDisabled,
          index,
          singlePack,
          getToolTipLabel,
          newQVDesign,
          disableSwappingMpackPills,
          softDisablePill,
        })
      : this.renderPillsWithoutToolTip({
          item,
          multipackToSelect,
          mpackBg,
          disableSwappingMpackPills,
          softDisablePill,
          index,
          singlePack,
          isDisabled,
          newQVDesign,
        });
  };

  MultipackTabWrapper = (disableSwappingMpackPills) => {
    const {
      initialMultipackMapping,
      TCPStyleType,
      selectedMultipack,
      TCPStyleQTY,
      singlePageLoad,
      TCPMultipackProductMapping,
      disableMultiPackTab,
      setInitialTCPStyleQty,
      currentProduct: { allProductId },
      initialFormValues,
      initialValues,
      isNewQVEnabled,
      isPDPRedesignEnabled,
    } = this.props;
    const newQVDesign = isNewQVEnabled;
    const getInitialFormVal = getFormValue(initialFormValues, initialValues);
    const getSelectedProductInformation = filterCurrentSelectedProduct(
      allProductId,
      getInitialFormVal
    );
    const softDisableMutiPack = getSoftDisableMutiPack(getSelectedProductInformation);
    const singlePack = this.pdpLabels && this.pdpLabels.lbl_multipack_single_text;
    const getSelectedVal = this.selectedVal(setInitialTCPStyleQty, TCPStyleQTY);
    const getUniqueVal =
      TCPMultipackProductMapping && initialMultipackMapping
        ? [
            ...new Set([
              ...TCPMultipackProductMapping,
              ...initialMultipackMapping,
              ...[TCPStyleQTY],
            ]),
          ]
        : TCPMultipackProductMapping;
    const multipackToSelect = getSelectedMultipack(
      selectedMultipack,
      TCPStyleQTY,
      MULTI_PACK_TYPE,
      singlePack
    );
    const findCheckMultipack = getUniqueVal?.length
      ? findMultipacks(
          TCPStyleType,
          getUniqueVal,
          singlePack,
          getSelectedVal,
          MULTI_PACK_TYPE,
          singlePageLoad
        )
      : [];
    const findCheck = findCheckMultipack && findCheckMultipack?.length > 1;
    const mpackBg = 'multipack-bg';

    return (
      <>
        {findCheck && (
          <>
            {isPDPRedesignEnabled ? (
              <div className="pack-label-wrapper">
                <span className="pack-label">Pack:</span>
                <span className="selected-pack-value">
                  {multipackToSelect === singlePack
                    ? multipackToSelect
                    : `${multipackToSelect}${renderLabel(
                        this.pdpLabels.lbl_multipack_pack_text,
                        'lbl_multipack_pack_text'
                      )}`}
                </span>
              </div>
            ) : null}
            <ul
              className={`multipack-tab ${newQVDesign ? 'quick-view-drawer-redesign' : ''}`}
              ref={this.mlistRef}
            >
              {findCheckMultipack.map((item, index) => {
                return (
                  (item === singlePack || !Number.isNaN(item)) &&
                  this.MultipackButton({
                    item,
                    multipackToSelect,
                    singlePack,
                    index,
                    disableMultiPackTab,
                    selectedMultipack,
                    softDisableMutiPack,
                    disableSwappingMpackPills,
                    mpackBg,
                    newQVDesign,
                  })
                );
              })}
            </ul>
          </>
        )}
      </>
    );
  };

  renderAddedToBagView = (outfitCarouselState, isOutfitCarousel) =>
    outfitCarouselState && isOutfitCarousel
      ? this.addedToMsgWrapperOutfit()
      : this.addedToMsgWrapper();

  getNewQVClass = (isNewQVEnabled) => {
    return isNewQVEnabled ? this.quickViewDrawerClass : '';
  };

  getBagPageGiftCardUrl = ({ isProductBrandOfSameDomain, crossDomain, pdpUrlFromBag }) => {
    return isProductBrandOfSameDomain ? pdpUrlFromBag : `${crossDomain}${pdpUrlFromBag}`;
  };

  getCurrentColorPdpUrl = (productInfo, currentColorEntry) => {
    const { seoToken, pdpUrl } = productInfo || {};
    const { pdpSeoUrl, pdpUrl: currentPdpUrl } = currentColorEntry || {};
    const currentColorPdpUrl = pdpSeoUrl || seoToken;
    return currentColorPdpUrl ? `/p/${currentColorPdpUrl}` : pdpUrl || currentPdpUrl;
  };

  getToPath = ({
    pdpToPath,
    isGiftCard,
    toPath,
    fromBagPage,
    isProductBrandOfSameDomain,
    currentColorPdpUrl,
    alternateBrand,
  }) => {
    const toPathNew = alternateBrand
      ? `${toPath}$brand=${alternateBrand?.toUpperCase()}`
      : `${toPath}`;
    const currentColorPdpUrlNew = alternateBrand
      ? `${currentColorPdpUrl}$brand=${alternateBrand?.toUpperCase()}`
      : `${currentColorPdpUrl}`;
    const pdpToPathNew = alternateBrand
      ? `${pdpToPath}$brand=${alternateBrand?.toUpperCase()}`
      : `${pdpToPath}`;
    if (isProductBrandOfSameDomain) {
      if (fromBagPage && isGiftCard) {
        return toPathNew;
      }
      return currentColorPdpUrlNew;
    }
    if (pdpToPathNew.includes('?pid=')) return pdpToPathNew.replace('?pid=', '/');
    return pdpToPathNew;
  };

  getBagPageGiftCardToPath = ({ isProductBrandOfSameDomain, crossDomain, pdpUrlFromBag }) => {
    return isProductBrandOfSameDomain
      ? getProductListToPath(pdpUrlFromBag)
      : `${crossDomain}${pdpUrlFromBag}`;
  };

  getAccessoryClass = (fromPage, isSecondaryAccessoriesData) => {
    if (fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') {
      return isSecondaryAccessoriesData ? 'accessory-container' : 'accessory-wrapper';
    }
    return '';
  };

  renderStickyButton = (trackProps, storeId, isHideOriginalPrice) => {
    const {
      isNewPDPEnabled,
      fitChanged,
      displayErrorMessage,
      handleFormSubmit,
      unbxdId,
      selectedQuantity,
      isLoading,
      formValues,
      setAnalyticsData,
      checkForOOSForVariant,
      isNewQVEnabled,
      uniqueKeyId,
      handleRatingClick,
      productInfo,
      currentProduct: { colorFitsSizesMap, primaryBrand },
      selectedColorProductId,
      imagesByColor,
      selectedColor,
      alternateBrand,
      isGiftCard,
      accessories,
      priceInfoAccessoryPresent,
      isAccessoryPresentMandatory,
      secondarySelectedAccessoryList,
      isHeaderScrollViewDisabled,
      stickyATBLoaded,
      isGlobalHeaderRedesignEnabled,
      isPDP,
      isSocialProofOnAtbButtonEnabled,
      isLoyaltyTierEnabled,
      loyaltyTierBenefits,
    } = this.props;
    const { pageShortName, addToBagTrackProduct, trackingCategories } = trackProps;
    const analyticsData = {
      eventName: 'cart add',
      pageShortName,
      products: [addToBagTrackProduct],
      customEvents: ['event61'],
      pageNavigationText: '',
      storeId,
      ...trackingCategories,
    };
    const { products } = analyticsData;
    const { isPickUpSelected } = this.state;
    const isPickupActive = isPickUpSelected !== DELIVERY_METHODS.HOME;
    const atbButtonLabel = this.getButtonLabel();
    const isSizeDisabled = this.checkIfSizeIsDisabled();
    const isAllSizeDisabled = this.checkIfAllSizeIsDisabled();
    const { fit, size } = formValues;
    const currentColorEntry =
      getMapSliceForColorProductId(colorFitsSizesMap, selectedColorProductId) || {};
    const { color } = currentColorEntry || {};
    const prices = getPrices(productInfo, color?.name, fit, size);
    const isBopisEligibleFlag = this.getBopisAvailability(currentColorEntry);

    const pickItUpInStoreLabel = this.showFindInStore()
      ? this.quickViewLabels?.pickItUpInStore
      : this.quickViewLabels?.selectStore;

    const isDisabled =
      isPickUpSelected === DELIVERY_METHODS.BOPIS
        ? checkForOOSForVariant || !isBopisEligibleFlag
        : checkForOOSForVariant || isAllSizeDisabled;
    const selectedSizeValue = this.getSelecterSizeValue();

    let imgUrl = imagesByColor[selectedColor?.name]?.basicImageUrl || '';
    let imgConfig = 't_pdp_imgswatch,f_auto,q_auto';

    if (isGiftCard && color?.imagePath) {
      imgUrl = color.imagePath;
      imgConfig = 'w_125';
    }
    imgUrl = imgUrl?.replace(/\.(mp4|webm|WEBM|MP4)$/, '.jpg');
    const imgData = {
      alt: color?.name,
      url: imgUrl,
    };
    const colorStr = color?.family || formValues?.color;
    const colorImageNameSuffix = currentColorEntry?.imageName?.toLowerCase();
    const colorName = String(colorStr).toLowerCase()?.replace(`-${colorImageNameSuffix}`, '');
    const portalId = isClient() && document.getElementById('stickyAtbPortal');
    const socialProofMessage = this.getSocialProofMsg();
    const isSocialProofMessageAvailable = socialProofMessage?.priorityMsg?.length > 0 && isPDP;
    const earlyAccessAvailability = this.getEarlyAccessAvailability();
    const isAvailable = this.isProductAvailableForAccessHours(
      earlyAccessAvailability,
      loyaltyTierBenefits
    );
    const isFutureDate = new Date(earlyAccessAvailability) > new Date();

    return this.shouldRenderStickyHeader(isPickupActive) && portalId
      ? ReactDOM.createPortal(
          <StickyAtbHeader
            fitChanged={fitChanged}
            displayErrorMessage={displayErrorMessage}
            handleFormSubmit={handleFormSubmit}
            unbxdId={unbxdId}
            selectedQuantity={selectedQuantity}
            isLoading={isLoading}
            setAnalyticsData={setAnalyticsData}
            checkForOOSForVariant={checkForOOSForVariant}
            isNewQVEnabled={isNewQVEnabled}
            isNewPDPEnabled={isNewPDPEnabled}
            uniqueKeyId={uniqueKeyId}
            analyticsData={analyticsData}
            handleRatingClick={handleRatingClick}
            productId={this.getProductId(products)}
            isSizeDisabled={isSizeDisabled}
            isAllSizeDisabled={isAllSizeDisabled}
            productInfo={productInfo}
            prices={prices}
            scrollIntoView={this.scrollIntoView}
            atbButtonLabel={atbButtonLabel}
            primaryBrand={primaryBrand || alternateBrand}
            imgConfig={imgConfig}
            imgData={imgData}
            isMobile={this.isMobile}
            pickItUpInStoreLabel={pickItUpInStoreLabel}
            handlePickupFormSubmit={this.handlePickupFormSubmit}
            isDisabled={isDisabled}
            isPickupActive={isPickupActive}
            selectedSizeValue={selectedSizeValue}
            colorName={colorName}
            isHideOriginalPrice={isHideOriginalPrice}
            accessories={accessories}
            priceInfoAccessoryPresent={priceInfoAccessoryPresent}
            isAccessoryPresentMandatory={isAccessoryPresentMandatory}
            secondarySelectedAccessoryList={secondarySelectedAccessoryList}
            isHeaderScrollViewDisabled={isHeaderScrollViewDisabled}
            stickyATBLoaded={stickyATBLoaded}
            isGlobalHeaderRedesignEnabled={isGlobalHeaderRedesignEnabled}
            isSocialProofMessageAvailable={isSocialProofMessageAvailable}
            isSocialProofOnAtbButtonEnabled={isSocialProofOnAtbButtonEnabled}
            socialProofMessage={socialProofMessage}
            isLoyaltyTierEnabled={isLoyaltyTierEnabled}
            earlyAccessAvailability={earlyAccessAvailability}
            isAvailable={isAvailable}
            isTireEnabledButton={isLoyaltyTierEnabled && isFutureDate && !isAvailable}
          />,
          portalId
        )
      : null;
  };

  renderAddToBagSection = (isBundleProduct, storeId, errorOnHandleSubmit, trackProps) => {
    const {
      pageShortName,
      productId,
      outfitPageShortName,
      addToBagTrackProduct,
      trackingCategories,
    } = trackProps;
    const {
      isOutfitCarousel,
      outfitCarouselState,
      isStyleWith,
      isPDP,
      isNewQVEnabled,
      productInfo,
      isNewPDPEnabled,
      fromPage,
    } = this.props;
    const { isGiftCard } = productInfo;

    const analyticsData = {
      eventName: 'cart add',
      pageShortName,
      products: [addToBagTrackProduct],
      customEvents: ['event61'],
      pageNavigationText: '',
      storeId,
      ...trackingCategories,
    };
    const socialProofMessage = this.getSocialProofMsg();
    const socialProofMessageCheck =
      !isNewPDPEnabled && isPDP && socialProofMessage?.variation === 'bottom';
    const giftCardNewPdpCheck = isGiftCard && isNewQVEnabled;
    const styleWithClass = 'style-with-btn';
    return (
      <Row
        fullBleed
        className={`${errorOnHandleSubmit && !isNewQVEnabled ? 'product-size-error' : ''}`}
      >
        <Col
          colSize={{ small: 12, medium: 12, large: 12 }}
          className="outfit-button-wrapper-desktop"
        >
          {!isBundleProduct && !isOutfitCarousel && this.renderOutfitButton()}
          {giftCardNewPdpCheck ? (
            <div className={`${giftCardNewPdpCheck ? 'new-gift-card-pdp' : ''}`}>
              <div
                className={`button-wrapper ${
                  isStyleWith ? `${styleWithClass}` : ''
                } ${this.getNewQVClass(isNewQVEnabled)} ${
                  isGiftCard && isNewQVEnabled ? 'giftCard' : ''
                }`}
              >
                {this.renderAddedToBagView(outfitCarouselState, isOutfitCarousel)}
                {this.getAddToBagButtonAction(
                  `desktop_${productId}`,
                  {
                    customEvents: [DEFAULT_EVENTS],
                    eventName: 'cart add',
                    pageShortName,
                    pageName: outfitPageShortName,
                    products: [addToBagTrackProduct],
                    storeId,
                    pageNavigationText: '',
                    ...trackingCategories,
                  },
                  this.ATC_BUTTON
                )}
              </div>
            </div>
          ) : (
            <div
              className={`button-wrapper ${
                isStyleWith ? `${styleWithClass}` : ''
              } ${this.getNewQVClass(isNewQVEnabled)} ${
                isGiftCard && isNewQVEnabled ? 'giftCard' : ''
              }`}
            >
              {this.renderAddedToBagView(outfitCarouselState, isOutfitCarousel)}
              {this.getAddToBagButtonAction(
                `desktop_${productId}`,
                {
                  customEvents: [DEFAULT_EVENTS],
                  eventName: 'cart add',
                  pageShortName,
                  pageName: outfitPageShortName,
                  products: [addToBagTrackProduct],
                  storeId,
                  pageNavigationText: '',
                  ...trackingCategories,
                },
                this.ATC_BUTTON
              )}
            </div>
          )}
        </Col>
        <Col
          colSize={{ small: 6, medium: 8, large: 12 }}
          className={`outfit-button-wrapper ${this.getAccessoryClass(
            fromPage,
            this.isSecondaryAccessories
          )}`}
        >
          {giftCardNewPdpCheck ? (
            <div className={`${giftCardNewPdpCheck ? 'new-gift-card-pdp' : ''}`}>
              <div
                className={`button-wrapper ${
                  isStyleWith ? `${styleWithClass}` : ''
                } ${this.getNewQVClass(isNewQVEnabled)} ${isGiftCard ? 'giftCard' : ''}`}
              >
                {this.renderAddedToBagView(outfitCarouselState, isOutfitCarousel)}
                {this.getAddToBagButtonAction(productId, analyticsData, this.ATC_BUTTON)}
                {this.renderStickyATCButton() && (
                  <div
                    className={`sticky-atc-wrapper${socialProofMessageCheck ? ' socialProof' : ''}`}
                  >
                    {this.addedToMsgWrapper('sticky')}
                    {this.getAddToBagButtonAction(
                      productId,
                      analyticsData,
                      `${this.ATC_BUTTON} stickyATC`
                    )}
                  </div>
                )}
              </div>
              {!isBundleProduct && this.renderOutfitButton()}
            </div>
          ) : (
            <>
              <div
                className={`button-wrapper ${
                  isStyleWith ? `${styleWithClass}` : ''
                } ${this.getNewQVClass(isNewQVEnabled)} ${isGiftCard ? 'giftCard' : ''}`}
              >
                {this.renderAddedToBagView(outfitCarouselState, isOutfitCarousel)}
                {this.getAddToBagButtonAction(productId, analyticsData, this.ATC_BUTTON)}
                {this.renderStickyATCButton() && (
                  <div
                    className={`sticky-atc-wrapper${socialProofMessageCheck ? ' socialProof' : ''}`}
                  >
                    {this.addedToMsgWrapper('sticky')}
                    {this.getAddToBagButtonAction(
                      productId,
                      analyticsData,
                      `${this.ATC_BUTTON} stickyATC`
                    )}
                  </div>
                )}
              </div>
              {!isBundleProduct && this.renderOutfitButton()}
            </>
          )}
        </Col>
      </Row>
    );
  };

  renderSimilarlink = (
    checkForOOSForVariant,
    isRecommendationAvailable,
    seeSimilarItems,
    soldOut,
    isBopisFilterOn
  ) => {
    const { storeSpecials } = this.props;
    return (
      <>
        {!(isBopisFilterOn || storeSpecials) &&
        checkForOOSForVariant &&
        isRecommendationAvailable ? (
          <div className="oos-similar-block">
            <div className="oos-similar-items">
              <span className="oos-similar-items-title">{soldOut}</span>
              <a href="#recommendation" className="oos-similar-items-link">
                {seeSimilarItems}
              </a>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  /**
   * This just holds the logic for rendering a UX timer
   */
  setCTAPerformanceTimer = () => {
    const { IsCallToActionVisible } = this.state;
    return IsCallToActionVisible ? <RenderPerf.Measure name={CALL_TO_ACTION_VISIBLE} /> : null;
  };

  getProductSummary = (keepAlive, handleMetaProps, isInWishList, isHideOriginalPrice) => {
    const {
      productDetailsPDP,
      productInfo,
      currencySymbol,
      currencyAttributes,
      onAddItemToFavorites,
      isLoggedIn,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      isLoading,
      wishList,
      hidePriceDisplay,
      isPerUnitPriceEnabled,
      isBrierleyPromoEnabled,
      onSetLastDeletedItemIdAction,
      TCPStyleQTY,
      deleteFavItemInProgressFlag,
      checkForOOSForVariant,
      currentProduct: { colorFitsSizesMap },
      selectedColorProductId,
      getGiftCardValue,
      isShowBrandNameEnabled,
      openModal,
      isPlcc,
      formValues,
      handleRatingClick,
      isPlccPriceOnPDP,
      isPDPRedesignEnabled,
      isPDP,
      ...otherProps
    } = this.props;
    const currentColorEntry =
      getMapSliceForColorProductId(colorFitsSizesMap, selectedColorProductId) || {};
    const { colorDisplayId, colorProductId } = currentColorEntry || {};
    const { isGiftCard, primaryBrand } = productInfo;
    return (
      <div className="product-summary-wrapper">
        <Product
          {...otherProps}
          isGiftCard={isGiftCard}
          productDetails={productDetailsPDP}
          currencySymbol={currencySymbol}
          selectedColorProductId={colorProductId}
          currencyAttributes={currencyAttributes}
          onAddItemToFavorites={onAddItemToFavorites}
          isLoggedIn={isLoggedIn}
          keepAlive={keepAlive}
          outOfStockLabels={this.outOfStockLabels}
          className="hide-on-mobile"
          AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
          removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
          isLoading={isLoading}
          isInWishList={isInWishList}
          isHasPlcc={isPlcc}
          hidePriceDisplay={hidePriceDisplay}
          isPerUnitPriceEnabled={isPerUnitPriceEnabled}
          isBrierleyPromoEnabled={isBrierleyPromoEnabled}
          TCPStyleQTY={TCPStyleQTY}
          onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
          wishList={wishList}
          deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
          isAfterPayDisplay={!checkForOOSForVariant}
          isOutfitPage={false}
          colorDisplayId={colorDisplayId}
          primaryBrand={primaryBrand}
          isShowBrandNameEnabled={isShowBrandNameEnabled}
          openModal={openModal}
          formValues={formValues}
          handleRatingClick={handleRatingClick}
          isHideOriginalPrice={isHideOriginalPrice}
          isPlccPriceOnPDP={isPlccPriceOnPDP}
          isPDPRedesignEnabled={isPDPRedesignEnabled && isPDP}
        />
        {isGiftCard ? (
          <div className="product-price-desktop-view">
            {isLoading ? (
              <LoaderSkelton />
            ) : (
              <ProductPrice
                offerPrice={parseInt(getGiftCardValue, 10)}
                listPrice={parseInt(getGiftCardValue, 10)}
                hideItemProp // prop is used to hide unwanted duplicate itemProp as we have duplicate ProductPrice component for web and mobile on PDP pages
                currencySymbol={currencySymbol}
                currencyAttributes={currencyAttributes}
                isGiftCard={isGiftCard}
                isPlcc={isPlcc}
                isPerUnitPriceEnabled={isPerUnitPriceEnabled}
                TCPStyleQTY={TCPStyleQTY}
                wishList={wishList}
                isAfterPayDisplay
                isHideOriginalPrice={isHideOriginalPrice}
                colorProductId={colorProductId}
                isPDPRedesignEnabled={isPDPRedesignEnabled && isPDP}
              />
            )}
          </div>
        ) : null}
        {isGiftCard ? (
          <div className="product-price-mobile-view">
            {isLoading ? (
              <LoaderSkelton />
            ) : (
              <ProductPrice
                listPrice={parseInt(getGiftCardValue, 10)}
                offerPrice={parseInt(getGiftCardValue, 10)}
                currencyAttributes={currencyAttributes}
                currencySymbol={currencySymbol}
                isPlcc={isPlcc}
                isPerUnitPriceEnabled={isPerUnitPriceEnabled}
                TCPStyleQTY={TCPStyleQTY}
                isAfterPayDisplay
                isHideOriginalPrice={isHideOriginalPrice}
                colorProductId={colorProductId}
                isPDPRedesignEnabled={isPDPRedesignEnabled && isPDP}
              />
            )}
          </div>
        ) : null}
      </div>
    );
  };

  multiPackIdChange = () => {
    const { colorDisplayId } = this.props;
    this.prevProdId = colorDisplayId;
  };

  onClickMultipackBtn = (e, index, item, singlePack) => {
    const {
      setSelectedMultipack,
      getDetails,
      currentProduct,
      onQuickViewOpenClick,
      fromPDP,
      isPDP,
      closePickupModal,
      setInitialTCPStyleQty,
      resetProductDetailsDynamicData,
      getQickViewSingleLoad,
      getDisableSelectedTab,
      isPickup,
      onPickUpOpenClick,
      fromBagPage,
      productInfoFromBag,
      availableTCPmapNewStyleId,
      alternateBrand,
      isPickUpSelected,
      fromPage,
      isTakeDownProduct,
      resetQuickViewDynamicData,
      onUpdateFit,
      checkForNewFits,
      currentProduct: { colorFitsSizesMap },
      selectedColor,
      isSplittingExtendedSizesEnabled,
    } = this.props;
    e.preventDefault();
    setTimeout(() => {
      const targetClassList = e.target?.classList;
      const targetClassArray = targetClassList ? [...targetClassList] : [];
      const newFitsCheck = checkForNewFits({
        colorFitsSizesMap,
        selectedColor,
        isSplittingExtendedSizesEnabled,
      });
      if (targetClassArray?.indexOf('multipack-bg') < 0) {
        onTabClickDetails({
          setSelectedMultipack,
          getDetails,
          currentProduct,
          onQuickViewOpenClick,
          fromPDP,
          isPDP,
          e,
          item,
          singlePack,
          setInitialTCPStyleQty,
          resetProductDetailsDynamicData,
          getQickViewSingleLoad,
          getDisableSelectedTab,
          closePickupModal,
          isPickup,
          onPickUpOpenClick,
          fromBagPage,
          productInfoFromBag,
          availableTCPmapNewStyleId,
          fromPills: true,
          alternateBrand,
          isBopisPickup: isPickUpSelected === 'bopis',
          fromPage,
          isTakeDownProduct,
          resetQuickViewDynamicData,
          ...(newFitsCheck ? { onUpdateFit } : {}),
        });
      }
      this.multiPackIdChange();
    }, 0);
  };

  qtySelector = () => {
    const { quantityList, isFromBagProductSfl, isOutfitCarousel, isStyleWith } = this.props;
    return (
      !isOutfitCarousel &&
      !isStyleWith &&
      this.renderQuantitySelector(
        isFromBagProductSfl,
        MiniBagSelect,
        quantityList,
        this.quantityChange
      )
    );
  };

  getProductCartError = (addToBagErrorId) => {
    const { currentProduct, errorOnHandleSubmit } = this.props;
    if (!addToBagErrorId) {
      return errorOnHandleSubmit;
    }
    return addToBagErrorId && addToBagErrorId === currentProduct.unbxdProdId
      ? errorOnHandleSubmit
      : '';
  };

  renderPills = (isPhysicalMpackEnabled, hideMultipackPills, disableSwappingMpackPills) => {
    const { isPDP } = this.props;
    const modalClass = isPDP ? '' : 'multipack-pills-css';
    return disableSwappingMpackPills && isPhysicalMpackEnabled && !hideMultipackPills ? (
      <div className={`edit-form-css ${modalClass}`}>
        <div
          className={`multipack-tab-edit-css ${disableSwappingMpackPills ? 'tooltip-style' : ''}`}
          ref={this.mTabRef}
        >
          {this.MultipackTabWrapper(disableSwappingMpackPills)}
        </div>
      </div>
    ) : null;
  };

  checkInWishlist = (wishList, productId) =>
    wishList && wishList[productId] && wishList[productId].isInDefaultWishlist;

  shouldRenderColorList = () => {
    const {
      isModalOpen,
      isOutfitCarousel,
      isBundleProduct,
      newColorList,
      isOutfitPage,
      colorList,
      isNewQVEnabled,
    } = this.props;
    if (colorList?.length === 1 && isNewQVEnabled) return false;
    if (isOutfitPage) return true;
    if (isBundleProduct && colorList?.length > 1) return true;
    if (!isModalOpen && !((newColorList && newColorList?.length) || isOutfitCarousel)) return false;
    return true;
  };

  getGender = (breadcrumbs) => {
    const gender =
      breadcrumbs && breadcrumbs[0] && breadcrumbs[0].displayName
        ? breadcrumbs[0].displayName.toLowerCase()
        : '';
    return gender === 'home' ? '' : gender;
  };

  trackBossBopisClick = (isBopisSelected, isBossSelected, productFormData) => {
    const {
      currentProduct,
      setAnalyticsData,
      storeId,
      breadCrumbs,
      userDefaultStore,
      trackClickDispatch,
    } = this.props;
    const { color, size, fit, quantity } = productFormData;
    const { listPrice, offerPrice, reviewsCount, ratings, generalProductId = '' } = currentProduct;
    let sku = '';
    let storeSearchDistance = '';
    let storeSearchCriteria = '';
    if (userDefaultStore) {
      sku = userDefaultStore?.productAvailability?.skuId;
      storeSearchDistance = userDefaultStore.distance;
      storeSearchCriteria = userDefaultStore?.basicInfo?.address?.zipCode;
    }
    const trackProduct = {
      colorId: generalProductId,
      color,
      id: generalProductId.split('_')[0],
      price: offerPrice,
      extPrice: listPrice,
      listPrice,
      pricingState: offerPrice < listPrice ? 'on sale' : 'full price',
      rating: ratings,
      reviews: reviewsCount,
      size,
      fit,
      quantity,
      sku,
      storeId,
      gender: this.getGender(breadCrumbs),
    };

    // Checking BOSS BOPIS for analytics
    let customEventsVal = '';
    let eventName = DEFAULT_EVENTS;
    if (isBopisSelected) {
      customEventsVal += 'event132';
      eventName = 'bopis cta click on pickup modal';
    }
    if (isBossSelected) {
      customEventsVal += 'event133';
      eventName = 'boss cta click on pickup modal';
    }

    trackClickDispatch({
      name: 'pickup_store_select',
      module: 'browse',
    });

    const analyticsTimer = setTimeout(() => {
      setAnalyticsData({
        customEvents: [customEventsVal],
        storeSearchCriteria,
        storeSearchDistance,
        eventName,
        products: [trackProduct],
        storeId,
        clickEvent: true,
        pageNavigationText: '',
      });
      clearTimeout(analyticsTimer);
    }, 300);
  };

  userStoreFromStorage = () => {
    return JSON.parse(getLocalStorage('defaultStore')) || '';
  };

  handleAddItemToCartInPickup = (isBopis, isBoss) => {
    const {
      addItemToCartInPickup,
      onCloseClick,
      currentProduct,
      fromPage: pageName,
      selectedFit,
      selectedColor,
      selectedQuantity,
      storeId,
      alternateBrand,
      alternateBrandFromUrl,
      accessories,
      secondarySelectedAccessoryList,
      accessoriesData,
      selectedAccessories,
      productInfo: product,
    } = this.props;
    const productInfoAccessoryData = product?.accessoriesData?.customizationType;

    const isMandatoryCustomization =
      productInfoAccessoryData === 'mandatory' ||
      accessoriesData?.customizationType === 'mandatory';
    const modifiedAccessories = markPriceIncluded(
      accessories || selectedAccessories,
      secondarySelectedAccessoryList,
      isMandatoryCustomization
    );
    const primaryBrand = currentProduct && currentProduct.primaryBrand;
    const brand = primaryBrand || alternateBrandFromUrl || alternateBrand || getBrand();
    const storeIdFromStorage = this.userStoreFromStorage()?.basicInfo?.id;
    const emptyFunc = () => {};
    const productFormData = {
      color: selectedColor && selectedColor.name,
      fit: selectedFit && selectedFit.name,
      size: this.getSelecterSizeValue(),
      wishlistItemId: false,
      quantity: selectedQuantity,
      isBoss,
      brand,
      storeLocId: storeId || storeIdFromStorage,
    };
    const productInfo = getCartItemInfo(currentProduct, productFormData);
    const { colorFitsSizesMap } = currentProduct || {};
    let payload = {
      productInfo,
      callback: onCloseClick || emptyFunc,
      fromPage: pageName || 'pdp',
      accessories: modifiedAccessories,
      bossDisabledFlags: colorFitsSizesMap?.[0]?.miscInfo?.bossDisabledFlags,
    };
    payload = this.setStorePickupJourney(payload, productInfo);
    this.trackBossBopisClick(isBopis, isBoss, productFormData);
    return addItemToCartInPickup(payload);
  };

  productDetailSkeletonCheck() {
    const { isLoading, isPDP, setInitialQuickViewLoad } = this.props;
    return isLoading && !isPDP && setInitialQuickViewLoad;
  }

  pickupSelectionUpdate(value) {
    const { setIsBopisSelected, setIsBossSelected, setIsSTHSelected, updatePickupSelectedState } =
      this.props;
    this.setState({ isPickUpSelected: value }, () => {
      updatePickupSelectedState(value);
    });

    setIsBopisSelected(value === DELIVERY_METHODS.BOPIS);
    setIsBossSelected(value === DELIVERY_METHODS.BOSS);
    setIsSTHSelected(value === DELIVERY_METHODS.HOME);
  }

  updateMultipackPill() {
    const { current } = this.mlistRef;
    const { className = '' } = current || {};

    if (className.includes('multipack-tab')) {
      const elements = Array.from(this.mlistRef.current.children);
      const index =
        elements &&
        elements.findIndex(
          (item) => item && item.className && item.className.includes('multipack-bg-wrapper')
        );
      const offsetLeftSize =
        this.mlistRef.current.children[index] && this.mlistRef.current.children[index].offsetLeft;
      if (this.mTabRef.current.scrollLeft !== offsetLeftSize) {
        this.mTabRef.current.scrollLeft = index >= 0 ? offsetLeftSize - 14 : 14;
      }
    }
  }

  // TODO: replace isOnlineExclusive = currentColorEntry?.miscInfo?.badge1?.defaultBadge;
  getBopisAvailability = (currentColorEntry, isStoreSpecialPriceEnabled) => {
    let isOnlineExclusive;
    let isBopisEligibleFlag;
    if (currentColorEntry) {
      isBopisEligibleFlag = currentColorEntry?.miscInfo?.isBopisEligible;
      isOnlineExclusive = getIsOnlineExclusive(currentColorEntry?.miscInfo);
    }
    if (isStoreSpecialPriceEnabled || getIsAllowOnlineProductPickupEnabled()) {
      return isBopisEligibleFlag;
    }

    return !isOnlineExclusive && isBopisEligibleFlag;
  };

  findQuantityByStoreId = (data, storeId) => {
    const item = data?.find((store) => store.storeId === storeId);
    return item ? item.quantity : 0;
  };

  checkNameKey = (obj) => {
    return obj?.name === '';
  };

  removeCartItem = () => {
    const {
      removeCartItem,
      clearCheckoutServerError,
      setCartItemsSflError,
      productInfoFromBag,
      currentProduct,
      closeQuickViewSizeModal,
      closePickupModal,
      isPickupModalOpen,
    } = this.props;
    const { generalProductId } = currentProduct;

    const { orderItemId: itemId } = productInfoFromBag || {};
    removeRecFromStorage(generalProductId);
    clearCheckoutServerError({});
    setCartItemsSflError(null);
    removeCartItem({
      itemId,
      pageView: 'myBag',
    });
    if (isPickupModalOpen) {
      closePickupModal({
        isModalOpen: false,
      });
      if (isAndroidWeb()) {
        document.querySelector('#__next').style.display = '';
      }
    } else closeQuickViewSizeModal();
  };

  getPickupButtonLabel = (fromBagPage, update, lblVal) => {
    return fromBagPage ? (
      <>{this.showFindInStore() ? update : this.quickViewLabels?.selectStore}</>
    ) : (
      <>{lblVal}</>
    );
  };

  renderPickupButton(newPDPCheck, update, currentColorEntry, isNewQVEnabled) {
    const {
      isLoading,
      currentProduct,
      fromBagPage,
      checkForOOSForVariant,
      fromPage,
      TCPStyleType = '',
      isBopisFilterOn,
      bopisItemInventory,
      isPickupPromotionPDPEnabled,
      userDefaultStore,
      isPDP,
      selectedSize,
      addedToBagBtnLoader,
      isStoreSpecialPriceEnabled,
      storeSpecials,
      loyaltyTierBenefits,
      isLoyaltyTierEnabled,
    } = this.props;
    const { pageName } = this.getPageName(currentProduct);
    const { isPickUpSelected, showAddedText } = this.state;
    const isPickupActive = isPickUpSelected === DELIVERY_METHODS.BOPIS;
    const isAllSizeDisabled = this.checkIfAllSizeIsDisabled();
    const earlyAccessAvailability = this.getEarlyAccessAvailability();
    const isFutureDate = new Date(earlyAccessAvailability) > new Date();
    const isAvailable = this.isProductAvailableForAccessHours(
      earlyAccessAvailability,
      loyaltyTierBenefits
    );
    const disableBtn = isLoyaltyTierEnabled && isFutureDate && !isAvailable;
    const isBopisEligibleFlag = this.getBopisAvailability(
      currentColorEntry,
      isStoreSpecialPriceEnabled
    );
    const isDisabled = isPickupActive
      ? checkForOOSForVariant || !isBopisEligibleFlag
      : checkForOOSForVariant || isAllSizeDisabled;
    const shouldDisableAddCta =
      !(fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') &&
      TCPStyleType === '0007';
    const storeId = userDefaultStore?.basicInfo?.id;
    const currentStoreInventory = this.findQuantityByStoreId(
      bopisItemInventory.inventoryResponse,
      storeId
    );
    let lblVal;
    if (this.showFindInStore()) {
      if (isPickupPromotionPDPEnabled && isPDP && isPickupActive) {
        if (this.checkNameKey(selectedSize)) {
          lblVal = this.quickViewLabels?.pickItUpInStore;
        } else {
          lblVal =
            currentStoreInventory > 0
              ? this.quickViewLabels?.pickItUpInStore
              : renderLabel(this.pdpLabels.lbl_show_in_stock_stores, 'lbl_show_in_stock_stores');
        }
      } else {
        lblVal = this.quickViewLabels?.pickItUpInStore;
      }
    } else {
      lblVal = this.quickViewLabels?.selectStore;
    }
    if (disableBtn) {
      lblVal = renderLabel(this.pdpLabels.lbl_add_to_bag_tier_based, 'lbl_add_to_bag_tier_based');
    }

    return (
      <ClickTracker
        clickData={{
          customEvents: ['event131'],
          pageName,
        }}
        className={`${
          newPDPCheck || isNewQVEnabled ? 'pdp-redesign-wrapper store-btn-redesign' : ''
        } btn-find-in-store-wrapper-quick-view-drawer-redesign`}
      >
        {(newPDPCheck || isNewQVEnabled) && (
          <div className="new-pdp-qty-selector">{this.qtySelector()}</div>
        )}
        <Button
          className={`button-find-in-store-quick-view-drawer-redesign ${
            isLoading ? this.disableClass : ''
          }${addedToBagBtnLoader ? ' add-to-bag-button-loader' : ''} ${
            isLoyaltyTierEnabled && disableBtn
          } loyalty-disabled`}
          disabled={
            isBopisFilterOn ||
            (isStoreSpecialPriceEnabled && storeSpecials && checkForOOSForVariant)
              ? false
              : isLoading || isDisabled || shouldDisableAddCta || disableBtn
          }
          buttonVariation="fixed-width"
          name="pickupStoreButton"
          onClick={(e) => {
            setTimeout(() => {
              this.handlePickupFormSubmit(e);
            }, 0);
          }}
        >
          {addedToBagBtnLoader && (
            <Image
              className="check-icon-outfits"
              width="20px"
              height="20px"
              src={getIconPath('circle-check-form-icon')}
              alt="reward-icon"
              aria-hidden="true"
            />
          )}
          {addedToBagBtnLoader
            ? showAddedText && 'Added'
            : this.getPickupButtonLabel(fromBagPage, update, lblVal)}
        </Button>
      </ClickTracker>
    );
  }

  getAccessoriesData = (
    accessoriesData,
    QVAccessoriesData,
    isSecondaryAccessories,
    isQuickView
  ) => {
    if (
      (isSecondaryAccessories || isQuickView) &&
      QVAccessoriesData &&
      QVAccessoriesData.accessoriesProductID
    ) {
      return QVAccessoriesData;
    }
    return accessoriesData === undefined ? QVAccessoriesData : accessoriesData;
  };

  isProductGift = (newCBMPdpAsPath) => {
    const lowerCasePath = newCBMPdpAsPath?.toLowerCase() || '';
    const isGift = lowerCasePath.includes('gift');
    const isCard = lowerCasePath.includes('card');

    return isGift && isCard;
  };

  getEarlyAccessFormattedDate = (earlyAccessAvailabilityDate) => {
    const earlyAccessDate = new Date(earlyAccessAvailabilityDate);
    const earlyAccessDay = String(earlyAccessDate.getUTCDate()).padStart(2, '0');
    const earlyAccessMonth = String(earlyAccessDate.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const earlyAccessYear = earlyAccessDate.getUTCFullYear();

    return `${earlyAccessMonth}/${earlyAccessDay}/${earlyAccessYear}`;
  };

  // eslint-disable-next-line
  render() {
    const {
      className,
      showAddToBagCTA,
      alternateSizes,
      isPickup,
      isBundleProduct,
      isATBErrorMessageDisplayed,
      quickViewPickup,
      storeId,
      isOutfitCarousel,
      currencySymbol,
      currencyAttributes,
      listPrice,
      offerPrice,
      isCanada,
      isPlcc,
      productDetailsToPath,
      currentProduct,
      isInternationalShipping,
      closeModal,
      isStyleWith,
      isPhysicalMpackEnabled,
      imageSwatchesToDisplay,
      checkForOOSForVariant,
      isRecommendationAvailable,
      addToBagErrorId,
      newColorList,
      hideMultipackPills,
      disableSwappingMpackPills,
      isAfterPayDisplay,
      isNewQVEnabled,
      fromBagPage,
      isFavoriteEdit,
      itemBrand,
      availableTCPmapNewStyleId,
      initialMultipackMapping,
      setInitialTCPStyleQty,
      currentProduct: { colorFitsSizesMap },
      selectedColorProductId,
      isMultiItemQVModal,
      productInfoFromBag,
      pdpUrlFromBag,
      goToPDPPage,
      isFamilyOutfitEnabled,
      isNewPDPEnabled,
      isPDP,
      selectedSize,
      formValues,
      keepAlive,
      pdpProductDetails,
      onAddItemToFavorites,
      isLoggedIn,
      wishList,
      resetCountUpdate,
      countUpdated,
      isPerUnitPriceEnabled,
      isBrierleyPromoEnabled,
      TCPStyleQTY,
      onSetLastDeletedItemIdAction,
      deleteFavItemInProgressFlag,
      primaryBrand,
      middlePromos,
      isShowBrandNameEnabled,
      openModal,
      alternateBrand,
      addToPickupError,
      accessoriesData,
      accessoriesDataQV,
      selectedAccessories,
      displayErrorMessage,
      handleRatingClick,
      priceAndRatingSection,
      isErrorMessageDisplayed,
      fromPage,
      isQuickView,
      isAccessoryMessageDisplayed,
      isAccessoriesEnabled,
      customFormName,
      setOOSErrorInBagQV,
      tempSecondarySelectedAccessoryList,
      mainItemBrand,
      varientCount,
      selectedColor,
      selectedFit,
      selectedQuantity,
      isNewPJPPDPRedesignEnabled,
      setPdpTabSectionName,
      isCrossBrandMerchandisingEnabled,
      resetSize,
      resetBopisSize,
      isBossSelected,
      isBopisSelected,
      openBIAShopAllDrawer,
      isShopAllDrawerOpen,
      isHideOriginalPriceAndMarchantTagEnabled,
      isPickUpSelectedState,
      isBossPickupEdit,
      isBopisPickupSelected,
      resetSTHSize,
      isPlccPriceOnPDP,
      disableAlsoAvailablePills,
      plpProductData,
      isPDPRedesignEnabled,
      isBopisFilterOn,
      setDataForPDP,
      productInfoQV,
      isMobileWebTileEnhancementEnabled,
      isSupressAtbModalOnBag,
      isSocialProofOnAtbButtonEnabled,
      isStickyAtbButtonOnQvEnabled,
      isLoyaltyTierEnabled,
      loyaltyTierBenefits,
      isTrueFitEnabled,
      ...otherProps
    } = this.props;
    const TCPPrimaryCategory = currentProduct?.TCPPrimaryCategory;
    const { accessoriesProductID } = accessoriesData || {};
    const { product } = (accessoriesDataQV && accessoriesDataQV[0]) || {};
    const QVAccessoriesData = product?.accessoriesData;
    const QVAccessoriesCustomizationType = QVAccessoriesData?.customizationType || '';
    const QVAccessoriesProductID = QVAccessoriesData?.accessoriesProductID || undefined;
    const isLowTier = isTier3Device();
    const {
      isPickUpSelected,
      colorListWithSelectedItemFirst,
      hasMounted,
      departments,
      filteredSwatches,
      departmentSwatches,
    } = this.state;
    const currentColorEntry =
      getMapSliceForColorProductId(colorFitsSizesMap, selectedColorProductId) || {};
    const { colorDisplayId, hardMarkDown } = currentColorEntry || {};
    const isInWishList = this.checkInWishlist(
      wishList,
      colorDisplayId || pdpProductDetails?.currentProduct?.generalProductId
    );
    const currentColorPdpUrl = this.getCurrentColorPdpUrl(currentProduct, currentColorEntry);
    const apiConfigObj = getAPIConfig();
     const { locale } = apiConfigObj;
    const { crossDomain, brandSpecificCrossDomain } = apiConfigObj;
    const currentSiteBrand = getBrand();
    const brand = (productInfoFromBag?.itemBrand || primaryBrand || '').toUpperCase();
    const isProductBrandOfSameDomain = !isEmpty(productInfoFromBag)
      ? currentSiteBrand?.toUpperCase() === brand
      : true;
    let toPath = isProductBrandOfSameDomain
      ? `/${getSiteId()}${currentColorPdpUrl}`
      : `${brandSpecificCrossDomain[brand]}/${getSiteId()}${currentColorPdpUrl}`;
    let pdpToPath =
      isProductBrandOfSameDomain || isCrossBrandMerchandisingEnabled
        ? getProductListToPath(currentColorPdpUrl)
        : `${brandSpecificCrossDomain[brand]}/${getSiteId()}${currentColorPdpUrl}`;
    toPath = alternateBrand ? `${toPath}$brand=${alternateBrand}` : `${toPath}`;
    pdpToPath = alternateBrand ? `${pdpToPath}$brand=${alternateBrand}` : `${pdpToPath}`;
    const { isGiftCard, pdpUrl, productId, generalProductId } = currentProduct;
    const isPlpPage = isClient() && window.location.pathname.indexOf(SLASH_C_ROUTE) !== -1;
    if (fromBagPage && isGiftCard) {
      const tempUrl = this.getBagPageGiftCardUrl({
        isProductBrandOfSameDomain,
        crossDomain,
        pdpUrlFromBag,
      });
      const pdpPath = tempUrl.split('/');
      pdpPath.shift();
      toPath = `/${pdpPath.join('/')}`;
      pdpToPath = this.getBagPageGiftCardToPath({
        isProductBrandOfSameDomain,
        crossDomain,
        pdpUrlFromBag,
      });
    }
    const { seoToken } = currentProduct;
    const addToBagError = this.getProductCartError(addToBagErrorId);
    let { sizeList, fitList, colorFitSizeDisplayNames } = this.props;
    colorFitSizeDisplayNames = {
      color: 'Color',
      fit: 'Fit',
      size: 'Size',
      ...colorFitSizeDisplayNames,
    };

    if (sizeList) {
      sizeList = fromJS(sizeList);
      fitList = fromJS(fitList);
    }

    const {
      errorMessage,
      fit: fitTitle,
      viewProductDetails = '',
      soldOut,
      seeSimilarItems,
      update,
      earlyAccessDateAvailable,
    } = this.plpLabels;
    const { TCPStyleType } = currentProduct || '';
    const hideQtyPdpCheck = isNewPDPEnabled;
    const isFromSearchPageQV =
      isQuickView && isClient() && window?.location?.pathname?.indexOf('/search/') !== -1;
    const socialProofMessage = this.getSocialProofMsg();
    const socialProofBottomEnabled =
      isNewPDPEnabled &&
      isPDP &&
      socialProofMessage?.variation === 'bottom' &&
      !isSocialProofOnAtbButtonEnabled;
    const trackProps = this.getTrackProps(this.props);
    const isSecondaryAccessoriesData = isGetSecondaryData(fromPage, QVAccessoriesProductID, isPDP);
    this.isSecondaryAccessories = isSecondaryAccessoriesData;
    const secondaryAccessoryAddCta = customFormName === 'secondAccessoryForm';
    const brandName = getBrandName(primaryBrand, alternateBrand) || mainItemBrand;

    const pdpToPathUrl = this.getToPath({
      pdpToPath,
      isGiftCard,
      toPath,
      fromBagPage,
      currentColorPdpUrl,
      isProductBrandOfSameDomain,
      alternateBrand,
    });
    if (isQuickView) {
      pdpToPath = `${pdpToPath}&isfromQuickView=${isQuickView}&color=${selectedColor?.name}&fit=${
        selectedFit?.name
      }&quantity=${selectedQuantity}&size=${
        selectedSize?.name
      }&isFromSearchPageQV=${isFromSearchPageQV}${
        TCPPrimaryCategory ? `&tcpPrimaryCategory=${TCPPrimaryCategory}` : ''
      }`;
    }
    if (isPlpPage) {
      pdpToPath = `${pdpToPath}&referer=categoryPage`;
    }

    const isCrossBrandProduct = primaryBrand == null ? false : primaryBrand !== getBrandInCaps();
    const cbmPdpToPath = pdpToPath.includes('/us')
      ? pdpToPath.split('/us').splice(1).join('')
      : pdpToPath;
    const getCrossBrandPDPURL = () => {
      let newToPath = cbmPdpToPath;
      if (fromPage === 'StoreDetail') {
        newToPath = `${newToPath}&fromStoreDetail=true`;
      }
      return isCrossBrandMerchandisingEnabled &&
        isCrossBrandProduct &&
        !newToPath?.includes('brand')
        ? `${newToPath}$brand=${primaryBrand?.toUpperCase()}`
        : `${newToPath}`;
    };

    const cbmPdpAsPath = pdpToPathUrl.includes('/us')
      ? pdpToPathUrl.split('/us').splice(1).join('')
      : pdpToPathUrl;
    const getCrossBrandPDPAsPathURL = () => {
      return isCrossBrandMerchandisingEnabled &&
        isCrossBrandProduct &&
        !cbmPdpAsPath?.includes('brand')
        ? `${cbmPdpAsPath}$brand=${primaryBrand?.toUpperCase()}`
        : `${cbmPdpAsPath}`;
    };
    const newCBMPdpUrl = getCrossBrandPDPURL();
    const newCBMPdpAsPath = getCrossBrandPDPAsPathURL();
    if (
      sizeList &&
      ((isPickup && isPickUpSelectedState === 'boss') ||
        isBossSelected ||
        isBossPickupEdit ||
        isPickUpSelected === 'boss')
    ) {
      resetSize(sizeList);
    }

    if (
      (isPickup && isPickUpSelectedState === 'bopis') ||
      isBopisSelected ||
      isPickUpSelected === 'bopis'
    ) {
      resetBopisSize(sizeList);
    }

    if (!fromBagPage && isQuickView && !isMultiItemQVModal && isPickUpSelected === 'home') {
      resetSTHSize(sizeList);
    }

    const isHideOriginalPrice = hideProductOriginalPrice(
      hardMarkDown,
      isHideOriginalPriceAndMarchantTagEnabled
    );
    const departmentPillsEnabled = !disableAlsoAvailablePills;
    const showAlsoAvailablePills =
      departmentPillsEnabled &&
      isPDP &&
      departmentSwatches &&
      (departmentSwatches.length > 1 || departments.length > 1);
    const atbButtonContainerClass = `add-to-bag-section-wrapper ${
      !isStickyAtbButtonOnQvEnabled && isQuickView && !isMultiItemQVModal
        ? 'mt-auto position-sticky pb-18'
        : ''
    } add-to-bag-container`;
    const earlyAccessAvailability = this.getEarlyAccessAvailability();
    const isFutureDate = new Date(earlyAccessAvailability) > new Date();
    const isAvailable = this.isProductAvailableForAccessHours(
      earlyAccessAvailability,
      loyaltyTierBenefits
    );

    return (
      <form
        className={`${className}${isPDPRedesignEnabled ? ' pdp-new-design-form' : ''} ${
          !isStickyAtbButtonOnQvEnabled && isQuickView && !isMultiItemQVModal && 'display-content'
        }`}
        noValidate
        data-primary-brand={currentProduct.primaryBrand}
      >
        {showAlsoAvailablePills && this.renderDepartmentList(departments)}
        {showAlsoAvailablePills && this.renderDepartmentSwatchList(filteredSwatches)}
        {this.renderPills(isPhysicalMpackEnabled, hideMultipackPills, disableSwappingMpackPills)}
        <Row className="edit-form-css">
          <Col colSize={{ small: 12, medium: 12, large: 12 }} className="edit-form-css-width">
            {this.renderSimilarlink(
              checkForOOSForVariant,
              isRecommendationAvailable,
              seeSimilarItems,
              soldOut,
              isBopisFilterOn
            )}
            {isAccessoriesEnabled &&
            isSecondaryAccessoriesData &&
            varientCount !== null &&
            varientCount <= 1 ? null : (
              <div className="select-value-wrapper">
                {this.shouldRenderColorList() &&
                  this.renderColorList(
                    colorListWithSelectedItemFirst,
                    colorFitSizeDisplayNames.color,
                    imageSwatchesToDisplay,
                    newColorList,
                    departmentPillsEnabled
                  )}
                {isMobileWebTileEnhancementEnabled && fromBagPage && productInfoFromBag?.skuId && (
                  <BodyCopy
                    fontFamily="secondary"
                    component="div"
                    fontSize="fs10"
                    color="gray.800"
                    fontWeight="semiBold"
                    textAlign="right"
                    className="upc-container"
                    dataLocator={getLocator('cart_item_upc')}
                  >
                    {`UPC: ${productInfoFromBag?.skuId}`}
                  </BodyCopy>
                )}
                <div className="quickview-mobile-price-section">
                  {priceAndRatingSection || null}
                </div>
                {isNewPDPEnabled && !(isPDPRedesignEnabled && isPDP) ? (
                  <div
                    className={`${isNewPDPEnabled ? 'new-pdp-product-detail-below-wrapper' : ''}`}
                  >
                    <Product
                      {...otherProps}
                      keepAlive={keepAlive}
                      outOfStockLabels={this.outOfStockLabels}
                      isGiftCard={isGiftCard}
                      productDetails={pdpProductDetails}
                      currencySymbol={currencySymbol}
                      selectedColorProductId={selectedColorProductId}
                      currencyAttributes={currencyAttributes}
                      onAddItemToFavorites={onAddItemToFavorites}
                      isLoggedIn={isLoggedIn}
                      reviewOnTop
                      hideItemProp // prop is used to hide unwanted duplicate itemProp as we have duplicate ProductPrice component for web and mobile on PDP pages
                      isHasPlcc={isPlcc}
                      isInWishList={isInWishList}
                      resetCountUpdate={resetCountUpdate}
                      socialProofMessage={socialProofMessage}
                      countUpdated={countUpdated}
                      isPerUnitPriceEnabled={isPerUnitPriceEnabled}
                      checkForOOSForVariant={checkForOOSForVariant}
                      isBrierleyPromoEnabled={isBrierleyPromoEnabled}
                      TCPStyleQTY={TCPStyleQTY}
                      onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
                      deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
                      wishList={wishList}
                      isLowTier={isLowTier}
                      isOutfitPage={false}
                      colorDisplayId={colorDisplayId}
                      isNewPDPEnabled={isNewPDPEnabled}
                      primaryBrand={primaryBrand}
                      isShowBrandNameEnabled={isShowBrandNameEnabled}
                      openModal={openModal}
                      formValues={formValues}
                      alternateBrand={alternateBrand}
                      handleRatingClick={handleRatingClick}
                      isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                      setPdpTabSectionName={setPdpTabSectionName}
                      isHideOriginalPrice={isHideOriginalPrice}
                      isPlccPriceOnPDP={isPlccPriceOnPDP}
                    />
                  </div>
                ) : null}

                {(isNewPDPEnabled || isNewQVEnabled) && !(isPDPRedesignEnabled && isPDP) ? (
                  <div
                    className={`${
                      isNewPDPEnabled || isNewQVEnabled ? 'product-summary-new-pdp' : ''
                    }`}
                  >
                    {this.getProductSummary(keepAlive, true, isInWishList, isHideOriginalPrice)}
                  </div>
                ) : null}

                {!isMultiItemQVModal &&
                  !isSecondaryAccessoriesData &&
                  this.renderPills(
                    isPhysicalMpackEnabled,
                    hideMultipackPills,
                    !disableSwappingMpackPills
                  )}
                {this.renderFitList(fitList, fitTitle || colorFitSizeDisplayNames?.fit)}
                {this.renderSizeList(
                  sizeList,
                  colorFitSizeDisplayNames,
                  errorMessage || addToPickupError,
                  addToBagError || addToPickupError,
                  currentColorEntry
                )}

                {isTrueFitEnabled && (
                  <div
                    className="tfc-fitrec-product"
                    data-styleid={selectedColorProductId}
                    data-locale={locale}
                  />
                )}

                {hasMounted &&
                  !isPickup &&
                  !isFamilyOutfitEnabled &&
                  this.renderAlternateSizes(alternateSizes)}
                {quickViewPickup() && this.renderUnavailableLink()}
                {!isNewQVEnabled && !isMultiItemQVModal && this.qtySelector()}
              </div>
            )}
            {hasMounted && <RenderPerf.Measure name={CONTROLS_VISIBLE} />}
          </Col>
        </Row>
        <div className="please-enter-an-error">
          {(isATBErrorMessageDisplayed || addToPickupError) &&
            !isNewPDPEnabled &&
            (!isSupressAtbModalOnBag || fromPage !== 'cart') &&
            ErrorComp(addToBagError || addToPickupError, showAddToBagCTA)}
        </div>
        {(fromBagPage ||
          (accessoriesProductID && accessoriesProductID?.length > 0) ||
          (QVAccessoriesProductID && QVAccessoriesProductID?.length > 0) ||
          isSecondaryAccessoriesData) &&
          isAccessoriesEnabled &&
          customFormName !== 'secondAccessoryForm' && (
            <AccessoriesContainer
              accessoriesData={this.getAccessoriesData(
                accessoriesData,
                QVAccessoriesData,
                isSecondaryAccessoriesData,
                isQuickView
              )}
              isPDP={isPDP}
              parentPdpUrl={pdpUrl}
              productId={productId}
              fromBagPage={fromBagPage}
              productInfoFromBag={productInfoFromBag}
              setOOSErrorInBagQV={setOOSErrorInBagQV}
              isAccessoryMessageDisplayed={isAccessoryMessageDisplayed}
              showAddToBagCTA={showAddToBagCTA}
              ErrorComp={ErrorComp}
              isSecondaryAccessories={isSecondaryAccessoriesData}
              QVAccessoriesCustomizationType={QVAccessoriesCustomizationType}
              secondarySelectedAccessoryList={tempSecondarySelectedAccessoryList}
              generalProductId={generalProductId}
              brandName={brandName}
            />
          )}
        {isOutfitCarousel && !isStyleWith && (
          <>
            <hr className="dotted-line" />
            <ProductPrice
              isOutfitPage
              currencySymbol={currencySymbol}
              currencyAttributes={currencyAttributes}
              listPrice={listPrice}
              offerPrice={offerPrice}
              isCanada={isCanada}
              isInternationalShipping={isInternationalShipping}
              isPlcc={isPlcc}
              isAfterPayDisplay={isAfterPayDisplay}
              isHideOriginalPrice={isHideOriginalPrice}
              colorProductId={selectedColorProductId}
            />
          </>
        )}
        {!isMultiItemQVModal ? (
          <div className={`${isNewPDPEnabled ? 'newPDPWrapper' : ''}`}>
            {isNewQVEnabled && !isPickup && !secondaryAccessoryAddCta && (
              <StyledFulfillmentSectionContainer>
                <div
                  className={`fulfillment-section-wrapper-quick-view-drawer-redesign ${
                    this.isSecondaryAccessories && TCPStyleType !== '0007' ? 'no-box-shadow' : ''
                  }`}
                >
                  {this.renderFulFilmentSection(
                    isMultiItemQVModal,
                    fromBagPage,
                    currentProduct,
                    currentColorEntry,
                    isFavoriteEdit,
                    className,
                    {
                      itemBrand,
                      availableTCPmapNewStyleId,
                      initialMultipackMapping,
                      setInitialTCPStyleQty,
                      fromPage,
                    }
                  )}
                  {TCPStyleType !== '0007' && (
                    <div className="view-product-details-qv-redesign">
                      <Anchor
                        dataLocator={getLocator('quick_view_View_Product_details')}
                        className="link-redirect"
                        to={newCBMPdpUrl}
                        asPath={newCBMPdpAsPath}
                        useRouterNavigation
                        handleLinkClick={async () => {
                          setDataForPDP({
                            productInfoQV: {
                              ...productInfoQV,
                              generalProductId: this.isProductGift(newCBMPdpAsPath)
                                ? 'gift'
                                : colorDisplayId,
                            },
                            formValuesQV: formValues,
                          });
                          if (isShopAllDrawerOpen) {
                            await BuyItAgainDynamicStore();
                            openBIAShopAllDrawer(false);
                          }
                          if (isPlpPage) {
                            window.isPdpLinkClicked = true;
                            setSessionStorage({
                              key: 'LAST_PAGE_PATH',
                              value: window.location.pathname,
                            });
                          }
                        }}
                      >
                        {!isPDP && (
                          <BodyCopy
                            className="product-link-fulfillment-quick-view-drawer-redesign"
                            fontSize="fs12"
                            fontFamily="secondary"
                            fontWeight="extrabold"
                          >
                            {this.quickViewLabels?.viewFullProductDetails}
                          </BodyCopy>
                        )}
                      </Anchor>
                    </div>
                  )}
                </div>
              </StyledFulfillmentSectionContainer>
            )}
            <PreOrderDate
              showIcon
              blockView
              paddingBottom={!isNewPDPEnabled}
              isNewQVEnabled={isNewQVEnabled}
              formValues={formValues}
              currentProduct={currentColorEntry}
            />
            {socialProofBottomEnabled ? (
              <div className="social-proof-desktop-bottom">
                <SocialProofMessage socialProofMessage={socialProofMessage} />
              </div>
            ) : null}

            {isStickyAtbButtonOnQvEnabled &&
              showAddToBagCTA &&
              isNewQVEnabled &&
              !secondaryAccessoryAddCta && (
                <div
                  className={`${
                    isNewQVEnabled && !isNewPDPEnabled ? atbButtonContainerClass : ''
                  } atb-or-pickup`}
                >
                  {isPickUpSelected === DELIVERY_METHODS.HOME
                    ? this.renderAddToBagSection(
                        isBundleProduct,
                        storeId,
                        addToBagError || addToPickupError,
                        trackProps
                      )
                    : this.renderPickupButton(
                        hideQtyPdpCheck,
                        update,
                        currentColorEntry,
                        isNewQVEnabled
                      )}
                  {this.renderStickyPickUp() && (
                    <div className="sticky-atc-wrapper">
                      {this.renderPickupButton(
                        hideQtyPdpCheck,
                        update,
                        currentColorEntry,
                        isNewQVEnabled
                      )}
                    </div>
                  )}
                  {this.renderStickyButton(trackProps, storeId, isHideOriginalPrice)}
                  {this.setCTAPerformanceTimer()}
                  {isSupressAtbModalOnBag && fromPage === 'cart' && (
                    <div ref={this.errorRef}>
                      {ErrorComp(this.getProductCartError() || addToPickupError, true)}
                    </div>
                  )}
                </div>
              )}
          </div>
        ) : null}
        {!showAddToBagCTA &&
          isNewQVEnabled &&
          !secondaryAccessoryAddCta &&
          fromBagPage &&
          isBossPickupEdit && (
            <div
              className={`${
                isNewQVEnabled && !isNewPDPEnabled ? atbButtonContainerClass : ''
              } atb-or-pickup`}
            >
              <>
                {this.renderAddToBagSection(
                  isBundleProduct,
                  storeId,
                  addToBagError || addToPickupError,
                  trackProps
                )}
              </>
            </div>
          )}
        {showAddToBagCTA && !isNewQVEnabled && !secondaryAccessoryAddCta && (
          <>
            {this.renderAddToBagSection(
              isBundleProduct,
              storeId,
              addToBagError || addToPickupError,
              trackProps
            )}
            {this.renderStickyButton(trackProps, storeId, isHideOriginalPrice)}
            {this.setCTAPerformanceTimer()}
          </>
        )}
        {productDetailsToPath && (
          <Anchor
            onClick={() => closeModal()}
            className="view-product-details"
            to={productDetailsToPath}
            asPath={`/p/${seoToken}`}
            underline
            fontSizeVariation="large"
          >
            {viewProductDetails}
          </Anchor>
        )}
        {!isStickyAtbButtonOnQvEnabled &&
          showAddToBagCTA &&
          isNewQVEnabled &&
          !secondaryAccessoryAddCta && (
            <div
              className={`${
                isNewQVEnabled && !isNewPDPEnabled ? atbButtonContainerClass : ''
              } atb-or-pickup`}
            >
              {/* <span>rendering this part</span> */}
              {isPickUpSelected === DELIVERY_METHODS.HOME
                ? this.renderAddToBagSection(
                    isBundleProduct,
                    storeId,
                    addToBagError || addToPickupError,
                    trackProps
                  )
                : this.renderPickupButton(
                    hideQtyPdpCheck,
                    update,
                    currentColorEntry,
                    isNewQVEnabled
                  )}
              {this.renderStickyPickUp() && (
                <div className="sticky-atc-wrapper">
                  {this.renderPickupButton(
                    hideQtyPdpCheck,
                    update,
                    currentColorEntry,
                    isNewQVEnabled
                  )}
                </div>
              )}
              {this.renderStickyButton(trackProps, storeId, isHideOriginalPrice)}
              {this.setCTAPerformanceTimer()}
              {isSupressAtbModalOnBag && fromPage === 'cart' && (
                <div ref={this.errorRef}>
                  {ErrorComp(this.getProductCartError() || addToPickupError, true)}
                </div>
              )}
            </div>
          )}
        {isLoyaltyTierEnabled && isFutureDate && !isAvailable && (
          <EarlyAccessDate isBundleProduct={isBundleProduct}>
            <BodyCopy fontSize="fs14" fontWeight="medium" fontFamily="secondary">
              {earlyAccessDateAvailable.replace(
                '##earlyAccessDate##',
                this.getEarlyAccessFormattedDate(earlyAccessAvailability)
              )}
            </BodyCopy>
          </EarlyAccessDate>
        )}
      </form>
    );
  }
}

const getEnableReinitializeValue = (props) => {
  if (props?.isQuickView) {
    return false;
  }
  return true;
};

export default compose(
  connect((state, props) => {
    const formName = props.customFormName || PRODUCT_ADD_TO_BAG;
    const { multiQVItemIndex, isMultiItemQVModal, isFBTEnabled, isQuickView } = props || {};

    let tmpFormName = '';

    if (isMultiItemQVModal) {
      tmpFormName = `${formName}-QV-${props.generalProductId}_${multiQVItemIndex}`;
    } else if (!isMultiItemQVModal && isQuickView && isFBTEnabled) {
      tmpFormName = `${formName}-QV-${props.generalProductId}`;
    } else {
      tmpFormName = `${formName}-${props.generalProductId}`;
    }
    return {
      form: tmpFormName,
      enableReinitialize: getEnableReinitializeValue(props),
    };
  }),
  reduxForm()
)(withStyles(ProductAddToBag, styles));

ProductAddToBag.propTypes = propTypesWeb;
ProductAddToBag.defaultProps = defaultPropsWeb;

export { ProductAddToBag as ProductAddToBagVanilla };
